"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dict = {
    11: 'id',
    21: 'idtype',
    22: 'machineid',
    24: 'filelist',
    25: 'dir',
    26: 'file',
    27: 'name',
    28: 'noOfFrames',
    29: 'fonts',
    30: 'font',
    31: 'height',
    32: 'x',
    33: 'y',
    34: 'fontName',
    35: 'charSet',
    36: 'xFile',
    37: 'textureFile',
    38: 'textureFile1',
    39: 'textureFile2',
    40: 'textureFile3',
    41: 'textureFile4',
    42: 'textureFile5',
    43: 'textureFile6',
    44: 'textureFile7',
    45: 'textureFile8',
    46: 'textureFile9',
    47: 'size',
    48: 'fullScreen',
    49: 'cube',
    50: 'center',
    51: 'side',
    52: 'animatedMesh',
    53: 'spriteTypes',
    54: 'spriteType',
    55: 'objectTypes',
    56: 'cubeType',
    57: 'meshType',
    58: 'mapMeshType',
    59: 'animatedMeshType',
    60: 'sprites',
    61: 'sprite',
    62: 'objects',
    63: 'group',
    64: 'animation',
    65: 'object',
    66: 'defaultAnimationTime',
    67: 'particleType',
    68: 'flareType',
    69: 'nr',
    70: 'resizeableSpriteType',
    71: 'textSpriteType',
    72: 'lightType',
    73: 'diffuse',
    74: 'specular',
    75: 'ambient',
    76: 'position',
    77: 'direction',
    78: 'range',
    79: 'falloff',
    80: 'attenuation',
    81: 'theta',
    82: 'phi',
    83: 'lightTypes',
    84: 'light',
    85: 'corneredTileSpriteType',
    86: 'color',
    87: 'arrowType',
    88: 'endAt',
    89: 'effect',
    90: 'effectFile',
    91: 'primitiveType',
    92: 'xAnimationFile',
    93: 'scale',
    94: 'mapTextType',
    95: 'graphicsSettings',
    96: 'refreshRate',
    97: 'firstRun',
    98: 'userAnisotropy',
    99: 'shadows',
    100: 'panelType',
    101: 'seasonInfo',
    102: 'origo',
    103: 'cameraMove',
    104: 'camera',
    105: 'start',
    106: 'stop',
    107: 'target',
    108: 'up',
    109: 'duration',
    110: 'speed',
    111: 'anti_alias_geometry',
    112: 'shadow_effect',
    113: 'dynamic_lights',
    114: 'format',
    115: 'left',
    116: 'right',
    117: 'centre',
    118: 'gamma',
    119: 'normal',
    120: 'width',
    121: 'gregoriandat',
    122: 'year',
    123: 'month',
    124: 'day',
    125: 'newday',
    126: 'guitypes',
    127: 'guiButtonType',
    128: 'upSprite',
    129: 'downSprite',
    130: 'dissableSprite',
    131: 'overSprite',
    132: 'quadTextureSprite',
    133: 'textBoxType',
    134: 'borderSize',
    135: 'parent',
    136: 'leftButton',
    137: 'rightButton',
    138: 'slider',
    139: 'track',
    140: 'scrollbarType',
    141: 'priority',
    142: 'buttonDrag',
    143: 'text',
    144: 'maxHeight',
    145: 'maxWidth',
    146: 'tooltip',
    147: 'tooltipText',
    148: 'delayedTooltipText',
    149: 'minValue',
    150: 'maxValue',
    151: 'stepSize',
    152: 'startValue',
    153: 'horizontal',
    154: 'staydownbutton',
    155: 'windowType',
    156: 'background',
    157: 'moveable',
    158: 'resizeableWindow',
    159: 'radioButton',
    160: 'radioButtonGroupType',
    161: 'verticalScrollbar',
    162: 'horizontalScrollbar',
    163: 'scrollbargroupType',
    164: 'radioScrollbar',
    165: 'dontRender',
    166: 'horizontalBorder',
    167: 'verticalBorder',
    168: 'listBoxItemType',
    169: 'listBoxType',
    170: 'editBoxType',
    171: '3dButtonType',
    172: 'buttonMesh',
    173: 'buttonText',
    174: 'buttonFont',
    175: '3dposition',
    176: 'fixedsize',
    177: '3dIconType',
    178: 'positionType',
    179: 'layout',
    180: 'multiSpriteButtonType',
    181: 'icon',
    182: 'iconType',
    183: 'dropDown',
    184: 'heading',
    185: 'dropDownMenuType',
    186: 'step',
    187: 'language',
    188: 'l_english',
    189: 'l_french',
    190: 'l_german',
    191: 'l_swedish',
    192: 'gui',
    193: 'graphics',
    194: 'orientation',
    195: 'checkbox',
    196: 'checkboxType',
    197: 'truncate',
    198: 'receiver',
    199: 'tickstamp',
    200: 'ordertype',
    201: 'server',
    202: 'client',
    203: 'commandlist',
    204: 'istargetasynchronous',
    205: 'port',
    206: 'string_address',
    207: 'session_name',
    208: 'status',
    209: 'address',
    210: 'basic_type',
    211: 'standardchatmessage',
    212: 'alluserlist',
    213: 'announcedone',
    214: 'channel',
    215: 'chattext',
    216: 'banuser',
    217: 'datetime',
    218: 'handler',
    219: 'identity',
    220: 'key',
    221: 'message',
    222: 'password',
    223: 'rank',
    224: 'row',
    225: 'type',
    226: 'user',
    227: 'win',
    228: 'userslist',
    229: 'game',
    230: 'dummy',
    231: 'sound_fx_volume',
    232: 'music_volume',
    233: 'scroll_speed',
    234: 'camera_rotation_speed',
    235: 'zoom_speed',
    236: 'mouse_speed',
    237: 'master_volume',
    238: 'version',
    239: 'executable',
    240: 'data',
    241: 'animatedType',
    242: 'requeststartown',
    243: 'startown',
    244: 'changeowner',
    245: 'newowner',
    246: 'vsync',
    247: 'debugmonitor',
    248: 'debug',
    249: 'pdxa',
    250: 'versionName',
    251: 'frames',
    252: 'frame',
    253: 'stance',
    254: 'indices',
    255: 'noOfTriangles',
    256: 'noOfVertices',
    257: 'vertices',
    258: 'l_italian',
    259: 'l_spanish',
    260: 'l_polish',
    261: 'textblock',
    262: 'systemmessage',
    263: 'personalmessage',
    264: 'requestusersgames',
    265: 'requestgame',
    266: 'sendgame',
    267: 'bodytexture',
    268: 'colortwo',
    269: 'static',
    270: 'animatedmaptext',
    271: 'maskedShieldType',
    272: 'spacing',
    273: 'membername',
    274: 'progressbartype',
    275: 'transparencecheck',
    276: 'soundeffect',
    277: 'pitch',
    278: 'pan',
    279: 'voicetype',
    280: 'soundeffects',
    281: 'upsound',
    282: 'downsound',
    283: 'oversound',
    284: 'clicksound',
    285: 'lockable',
    286: 'drag',
    287: 'volume',
    288: 'instantTextBoxType',
    289: 'shortcut',
    290: 'writetochatbuffer',
    291: 'chatbuffer',
    292: 'chatmessage',
    293: 'loadType',
    294: 'norefcount',
    295: 'bitmapfont',
    296: 'bitmapfonts',
    297: 'colorcodes',
    298: 'progressbar3dType',
    299: 'countrychat',
    300: 'locatorname',
    301: 'locatormatrix',
    302: 'adapter',
    303: 'gunSmoke',
    304: 'EffectStartFrame',
    305: 'starttransfer',
    306: 'sendchunk',
    307: 'chunkreceived',
    308: 'ledger_data',
    309: 'ledger_data_x',
    310: 'ledger_data_y',
    311: 'income_statistics',
    312: 'nation_size_statistics',
    313: 'inflation_statistics',
    314: 'offset',
    315: 'multisampling',
    316: 'anisotropicFiltering',
    317: 'upper',
    318: 'lower',
    319: 'allwaystransparent',
    320: 'threeDguiType',
    321: 'shadowSize',
    322: 'ambient_volume',
    323: 'luafunction_buttonclick',
    324: 'l_czech',
    325: 'l_hungarian',
    326: 'l_dutch',
    327: 'l_portugese',
    328: 'l_russian',
    329: 'l_finnish',
    330: 'actorfile',
    331: 'idle',
    332: 'attack',
    333: 'move',
    334: 'OverlappingElementsBoxType',
    335: 'luaClick',
    336: 'tileSpriteType',
    337: 'retargeting',
    338: 'attach',
    339: 'PieChartType',
    340: 'BarGraphType',
    341: 'billboardType',
    342: 'rotation',
    343: 'offset2',
    344: 'offset3',
    345: 'offset4',
    346: 'font_size',
    347: 'anisotropic_filtering',
    348: 'multi_sampling',
    349: 'scrollingSprite',
    350: 'node',
    351: 'attachId',
    352: 'rangeLimitMin',
    353: 'rangeLimitMax',
    354: 'rangeLimitMinIcon',
    355: 'rangeLimitMaxIcon',
    356: 'useRangeLimit',
    357: 'none',
    358: 'BarChartType',
    359: 'long_float',
    360: 'LineChartType',
    361: 'linewidth',
    362: 'flipu',
    363: 'flipv',
    364: 'pdx_tooltip',
    365: 'pdx_tooltip_delayed',
    366: 'use_animation',
    367: 'vertical',
    368: 'cull_distance',
    369: 'tilingCenter',
    370: 'color_override',
    371: 'first_on_top',
    372: 'path',
    373: 'dependencies',
    374: 'steam_id',
    375: 'pdx_id',
    376: 'archive',
    377: 'checksum',
    378: 'affects_checksum',
    379: 'has_set_language',
    380: 'click_to_front',
    381: 'gamersgate_id',
    382: 'replace_path',
    383: 'user_dir',
    384: 'pdxmesh',
    385: 'pdxparticle',
    386: 'diplomacy_construction',
    387: 'merchant_construction',
    388: 'chat_message',
    389: 'chat_user_joined',
    390: 'chat_user_left',
    391: 'chat_user_joined_channel',
    392: 'chat_user_left_channel',
    393: 'chat_new_channel',
    394: 'chat_close_channel',
    395: 'chat_sync',
    396: 'chat_request_sync',
    397: 'cursor',
    398: 'show_position',
    399: 'hide_position',
    400: 'animation_type',
    401: 'animation_time',
    402: 'accelerated',
    403: 'decelerated',
    404: 'smoothstep',
    405: 'linear',
    406: 'can_be_lowres',
    407: 'particle',
    408: 'subsystem',
    409: 'max_amount',
    410: 'emission',
    411: 'velocity',
    412: 'life',
    413: 'yaw',
    414: 'force',
    415: 'texture',
    416: 'end',
    417: 'amount',
    418: 'op',
    419: 'repeat',
    420: 'curve',
    421: 'z',
    422: 'w',
    423: 'alpha',
    424: 'time',
    425: 'mass',
    426: 'sort',
    427: 'invert',
    428: 'r',
    429: 'g',
    430: 'b',
    431: 'a',
    432: 'shader',
    433: 'roll',
    434: 'particle_pitch',
    435: 'particle_roll',
    436: 'intensity',
    437: 'radius',
    438: 'entity',
    439: 'state',
    440: 'event',
    441: 'sound',
    442: 'animation_speed',
    443: 'animation_blend_time',
    444: 'loop_animation',
    445: 'min_gui',
    446: 'chance',
    447: 'clone_entity',
    448: 'keep_particle',
    449: 'clone',
    450: 'loop_time',
    451: 'frame_animation',
    452: 'animation_rate_fps',
    453: 'animation_rate_spf',
    454: 'looping',
    455: 'play_on_show',
    456: 'frameAnimatedSpriteType',
    457: 'pause_on_loop',
    458: 'hint_tag',
    459: 'disable_time_widget',
    460: 'childsystem',
    461: 'border_color',
    462: 'always_load',
    463: 'tags',
    464: 'picture',
    465: 'emission_pulse_duration',
    466: 'emission_pulse_silence',
    467: 'greater_than',
    468: 'less_than',
    469: 'borderless',
    470: 'alwaystransparent',
    471: 'division',
    472: 'next_state',
    473: 'max_resolution',
    474: 'trigger_once',
    475: 'state_time',
    476: 'time_offset',
    477: 'velocity_yaw',
    478: 'velocity_pitch',
    479: 'emitter_yaw',
    480: 'emitter_pitch',
    481: 'emitter_type',
    482: 'sphere_emitter_radius',
    483: 'sphere_emitter_yaw',
    484: 'sphere_emitter_pitch',
    485: 'box_emitter_x',
    486: 'box_emitter_y',
    487: 'box_emitter_z',
    488: 'steps',
    489: 'overlay',
    490: 'animationmaskfile',
    491: 'animationtexturefile',
    492: 'animationrotation',
    493: 'animationlooping',
    494: 'animationtime',
    495: 'animationdelay',
    496: 'animationtype',
    497: 'animationblendmode',
    498: 'animationtexturescale',
    499: 'default_state',
    500: 'cull_radius',
    501: 'playback_rate',
    502: 'animationframes',
    503: 'animationrotationoffset',
    504: 'animationtriggerframes',
    505: 'propagate_state',
    507: 'smoothListboxType',
    508: 'game_data',
    509: 'ui',
    510: 'font_definition',
    511: 'locator',
    512: 'parent_joint',
    513: 'hsv',
    514: 'bold',
    515: 'italic',
    516: 'underline',
    517: 'strikethrough',
    518: 'hyperlink',
    519: 'label',
    520: 'image',
    521: 'localization',
    522: 'includes',
    523: 'samplers',
    524: 'index',
    525: 'magfilter',
    526: 'minfilter',
    527: 'mipfilter',
    528: 'addressu',
    529: 'addressv',
    530: 'mipmaplodbias',
    531: 'mipmapmaxlod',
    532: 'mipmapminlod',
    533: 'vertexstruct',
    534: 'constantbuffer',
    535: 'vertexshader',
    536: 'pixelshader',
    537: 'maincode',
    538: 'code',
    539: 'defines',
    540: 'blendstate',
    541: 'blendenable',
    542: 'alphatocoverage',
    543: 'alphatest',
    544: 'sourceblend',
    545: 'destblend',
    546: 'blendop',
    547: 'sourcealpha',
    548: 'destalpha',
    549: 'blendopalpha',
    550: 'writemask',
    551: 'depthstencilstate',
    552: 'depthenable',
    553: 'depthwritemask',
    554: 'depthfunction',
    555: 'stencilenable',
    556: 'stencilreadmask',
    557: 'stencilwritemask',
    558: 'frontstencilfailop',
    559: 'frontstencildepthfailop',
    560: 'frontstencilpassop',
    561: 'frontstencilfunc',
    562: 'rasterizerstate',
    563: 'fillmode',
    564: 'cullmode',
    565: 'frontccw',
    566: 'depthbias',
    567: 'depthbiasclamp',
    568: 'slopescaledepthbias',
    569: 'scissor',
    570: 'multisample',
    571: 'framedirectiony',
    572: 'get_state_from_parent',
    573: 'music',
    574: 'local_space',
    575: 'local_force',
    576: 'sender',
    577: 'masking_texture',
    578: 'centerPosition',
    579: 'rgb',
    580: 'hex',
    581: 'colors',
    582: 'loop',
    583: 'instancing',
    584: 'stop_on_state_change',
    585: 'no_clicksound',
    586: 'dev_master_volume',
    587: 'ignore_tab_navigation',
    588: 'sounds',
    589: 'volume_random_offset',
    590: 'min_distance',
    591: 'max_distance',
    592: 'height_scale',
    593: 'weight',
    594: 'weighted_sound',
    595: 'icons_add_height',
    596: 'particle_yaw',
    597: 'rotation_speed',
    598: 'rotation_speed_yaw',
    599: 'rotation_speed_pitch',
    600: 'rotation_speed_roll',
    601: 'vertical_alignment',
    602: 'top',
    603: 'bottom',
    604: 'icon_scale',
    605: 'is3d',
    606: 'trail',
    607: 'billboard',
    608: 'slave_particles',
    609: 'video',
    610: 'affects_compatability',
    611: 'supported_version',
    612: 'containerWindowType',
    613: 'extendedScrollbarType',
    614: 'add_horizontal',
    615: 'max_slots',
    616: 'max_slots_vertical',
    617: 'max_slots_horizontal',
    618: 'padding',
    619: 'slotsize',
    620: 'dropDownBoxType',
    621: 'show_animation_type',
    622: 'hide_animation_type',
    623: 'show_animation_time',
    624: 'hide_animation_time',
    625: 'buttontype',
    626: 'scroll_wheel_factor',
    627: 'autohide_scrollbars',
    628: 'drag_scroll',
    629: 'gridboxtype',
    630: 'margin',
    631: 'clipping',
    632: 'upper_left',
    633: 'upper_right',
    634: 'lower_left',
    635: 'lower_right',
    636: 'center_up',
    637: 'center_down',
    638: 'increaseButton',
    639: 'decreaseButton',
    640: 'tileSize',
    641: 'clickonly',
    642: 'expandButton',
    643: 'expandedWindow',
    644: 'contractOnLeave',
    645: 'hideHeaderOnExpand',
    646: 'expandedOnTop',
    647: 'browserType',
    648: 'curveGraphType',
    649: 'callback_type',
    650: 'callback_argument',
    651: 'web_link',
    652: 'widget',
    653: 'machine',
    654: 'gui_scale',
    655: 'legacy_lazy_load',
    656: 'scrollbar_side',
    657: 'fade_time',
    658: 'fade_type',
    659: 'cursor_offset',
    660: 'text_color_code',
    661: 'directory',
    662: 'file_extension',
    663: 'sub_directories',
    664: 'show_sound',
    665: 'hide_sound',
    666: 'private',
    667: 'maxanisotropy',
    668: 'unum64',
    669: 'camera_speed',
    670: 'centered_zoom_in',
    671: 'camera_tilt',
    672: 'camera_strategy',
    673: 'preload_textures',
    674: 'auto',
    675: 'min',
    676: 'max',
    677: 'meshsettings',
    678: 'shader_file',
    679: 'hide',
    680: 'alphamaskfile',
    681: 'texturesize',
    682: 'max_audible',
    683: 'max_audible_behaviour',
    684: 'delay_random_offset',
    685: 'fade_out',
    686: 'fade_in',
    687: 'movable',
    688: 'tint',
    689: 'use_special_chars',
    690: 'dragButtonType',
    691: 'user_blob',
    692: 'launcher_sound',
    693: 'remote_file_id',
    694: 'description_file',
    695: 'category',
    696: 'center_left',
    697: 'center_right',
    698: 'textcolors',
    699: 'default_clicksound',
    700: 'default_oversound',
    701: 'default_downsound',
    702: 'default_upsound',
    703: 'open_categories',
    704: 'ignore_special_chars',
    705: 'overlay_frames_per_row',
    706: 'overlay_rows',
    707: 'third_party_warn',
    708: 'third_party_content',
    709: 'extra_shortcut',
    710: 'graceful_exit',
    711: 'normal_or_historical_nations',
    712: 'disallow_random_new_world',
    713: 'if_resolution',
    714: 'max_height',
    715: 'min_height',
    716: 'max_width',
    717: 'min_width',
    718: 'compressed',
    719: 'hard_check',
    720: 'local_check',
    721: 'randomlog',
    722: 'hotjoinlog',
    723: 'randomlog_stack',
    724: 'randomlog_frames',
    725: 'enable_leaderboard',
    727: 'requires_login',
    728: 'free_version_of_steam_id',
    729: 'free_version_of_name',
    730: 'app_name',
    945: 'rail_id',
    950: 'filename',
    953: 'sync',
    954: 'localizable_name',
    978: 'etag',
    981: 'pops_id',
    983: 'sync_status',
    993: 'conflict_resolved',
    994: 'msgr_id',
    995: 'game_ui_scale',
    996: 'scaled_path',
    997: 'egs_id',
    998: 'local_checksum',
    999: 'server_checksum',
    1000: 'egs_staging_id',
    1001: 'auth_token',
    1002: 'egs_prod_id',
    10000: 'add_treasury',
    10001: 'add_years_of_income',
    10002: 'add_prestige',
    10003: 'add_legitimacy',
    10004: 'add_inflation',
    10005: 'add_stability',
    10006: 'add_adm_power',
    10007: 'add_dip_power',
    10008: 'add_mil_power',
    10009: 'war_exhaustion',
    10010: 'add_manpower',
    10011: 'add_army_tradition',
    10012: 'add_navy_tradition',
    10013: 'add_badboy',
    10014: 'add_infamy',
    10015: 'custom_tooltip',
    10016: 'set_capital',
    10017: 'change_religion',
    10018: 'enable_religion',
    10019: 'add_core',
    10020: 'remove_core',
    10021: 'remove_core_from',
    10022: 'add_temp_claim',
    10023: 'remove_temp_claim',
    10024: 'change_primary_culture',
    10025: 'add_accepted_culture',
    10026: 'remove_accepted_culture',
    10027: 'culture_group_union',
    10028: 'elector',
    10029: 'change_government',
    10030: 'change_tag',
    10031: 'change_technology_group',
    10032: 'change_unit_type',
    10033: 'add_province_modifier',
    10034: 'add_country_modifier',
    10035: 'add_hre_member_modifier',
    10036: 'add_hre_emperor_modifier',
    10037: 'set_country_flag',
    10038: 'clr_country_flag',
    10039: 'set_province_flag',
    10040: 'clr_province_flag',
    10041: 'set_global_flag',
    10042: 'clr_global_flag',
    10043: 'create_revolt',
    10044: 'create_pirate',
    10045: 'create_native',
    10046: 'change_siege',
    10047: 'change_native_ferocity',
    10048: 'change_native_hostileness',
    10049: 'change_native_size',
    10050: 'add_base_tax',
    10051: 'missionaries',
    10052: 'merchants',
    10053: 'colonists',
    10054: 'diplomats',
    10055: 'add_colonysize',
    10056: 'multiply_colonysize',
    10057: 'hre',
    10059: 'discover',
    10060: 'cot',
    10061: 'add_building',
    10062: 'remove_building',
    10063: 'change_trade_goods',
    10064: 'change_culture',
    10065: 'add_casus_belli',
    10066: 'remove_casus_belli',
    10067: 'reverse_add_casus_belli',
    10068: 'reverse_remove_casus_belli',
    10069: 'change_relation',
    10070: 'cede_province',
    10071: 'inherit',
    10072: 'vassalize',
    10073: 'release',
    10074: 'remove_advisor',
    10075: 'kill_advisor',
    10076: 'every_country',
    10077: 'every_ally',
    10078: 'every_local_enemy',
    10079: 'random_local_enemy',
    10080: 'every_heretic_province',
    10081: 'every_owned_province',
    10082: 'random_country',
    10083: 'every_core_province',
    10084: 'every_core_country',
    10085: 'every_elector',
    10086: 'random_owned_province',
    10087: 'every_province',
    10088: 'every_neighbor_province',
    10089: 'every_neighbor_country',
    10090: 'every_empty_neighbor_province',
    10091: 'every_known_country',
    10092: 'random_neighbor_country',
    10093: 'random_neighbor_province',
    10094: 'random_center_of_trade',
    10095: 'random_province',
    10096: 'random_known_country',
    10097: 'random_core_country',
    10098: 'random_core_province',
    10099: 'random_ally',
    10100: 'random_elector',
    10101: 'every_center_of_trade',
    10102: 'every_sphere',
    10103: 'random_sphere',
    10104: 'add_to_sphere',
    10105: 'remove_from_sphere',
    10106: 'every_rival_country',
    10107: 'random_rival_country',
    10108: 'every_enemy_country',
    10109: 'random_enemy_country',
    10110: 'set_revolution_target',
    10111: 'declare_war',
    10112: 'cavalry',
    10113: 'infantry',
    10114: 'artillery',
    10115: 'big_ship',
    10116: 'heavy_ship',
    10117: 'light_ship',
    10118: 'transport',
    10119: 'galley',
    10120: 'loan_size',
    10121: 'remove_fow',
    10122: 'change_controller',
    10123: 'add_imperial_influence',
    10124: 'add_scaled_imperial_influence',
    10125: 'add_papal_influence',
    10126: 'add_heir_claim',
    10127: 'country_event',
    10128: 'province_event',
    10129: 'remove_province_modifier',
    10130: 'remove_country_modifier',
    10131: 'remove_hre_member_modifier',
    10132: 'remove_hre_emperor_modifier',
    10133: 'add_revolt_risk',
    10134: 'create_marriage',
    10135: 'create_alliance',
    10136: 'create_admiral',
    10137: 'create_explorer',
    10138: 'create_conquistador',
    10139: 'create_general',
    10140: 'create_colony',
    10141: 'define_ruler',
    10142: 'define_heir',
    10143: 'remove_merchant',
    10144: 'send_merchant',
    10145: 'kill_ruler',
    10146: 'kill_heir',
    10147: 'kill_leader',
    10148: 'define_admiral',
    10149: 'define_explorer',
    10150: 'define_conquistador',
    10151: 'define_general',
    10152: 'random_empty_neighbor_province',
    10153: 'create_vassal',
    10154: 'break_union',
    10155: 'add_nationalism',
    10156: 'force_converted',
    10157: 'internal_hre_cb',
    10158: 'imperial_ban_allowed',
    10159: 'dismantle_hre',
    10160: 'set_papacy_active',
    10161: 'create_advisor',
    10162: 'define_advisor',
    10163: 'set_variable',
    10164: 'change_variable',
    10165: 'change_province_name',
    10166: 'rename_capital',
    10167: 'add_ai_strategy',
    10168: 'fixed_ai_strategy',
    10169: 'spawn_rebels',
    10170: 'add_faction_influence',
    10171: 'random',
    10172: 'random_list',
    10173: 'add_faction',
    10174: 'remove_faction',
    10175: 'free_vassal',
    10176: 'white_peace',
    10177: 'revoke_reform',
    10178: 'hidden_effect',
    10179: 'if',
    10180: 'random_heretic_province',
    10181: 'add_claim',
    10182: 'remove_claim',
    10183: 'add_patriarch_authority',
    10184: 'add_opinion',
    10185: 'reverse_add_opinion',
    10186: 'remove_opinion',
    10187: 'reverse_remove_opinion',
    10188: 'random_trade_node',
    10189: 'random_active_trade_node',
    10190: 'add_ruler_modifier',
    10191: 'add_trade_modifier',
    10192: 'remove_trade_modifier',
    10193: 'recall_merchant',
    10194: 'add_trade_node_income',
    10195: 'every_active_trade_node',
    10196: 'add_piety',
    10197: 'add_mercantilism',
    10198: 'add_unit_construction',
    10199: 'form_coalition_against',
    10200: 'random_coalition_member',
    10201: 'every_coalition_member',
    10202: 'add_republican_tradition',
    10203: 'set_dynasty',
    10204: 'add_permanent_province_modifier',
    10205: 'add_reform_desire',
    10206: 'swap_free_idea_group',
    10207: 'declare_war_with_cb',
    10208: 'build_to_forcelimit',
    10209: 'add_war_exhaustion',
    10210: 'negative_power',
    10212: 'set_ai_attitude',
    10213: 'set_ai_personality',
    10214: 'rebuild_ai_attitudes',
    10215: 'rebuild_ai_priorities',
    10216: 'every_target_province',
    10217: 'discover_province',
    10218: 'random_target_province',
    10219: 'province_highlight',
    10220: 'direction_pointer',
    10221: 'set_allow_female_emperor',
    10222: 'random_trade_node_member_province',
    10223: 'every_trade_node_member_province',
    10224: 'random_trade_node_member_country',
    10225: 'every_trade_node_member_country',
    10226: 'disband_rebels',
    10227: 'set_in_empire',
    10228: 'discover_country',
    10229: 'undiscover_country',
    10230: 'undiscover_province',
    10231: 'change_adm',
    10232: 'change_mil',
    10233: 'change_dip',
    10234: 'placeholder',
    10235: 'provinceType',
    10236: 'provinceBorderType',
    10237: 'flagType',
    10238: 'shieldtype',
    10239: 'eu3dialogtype',
    10240: 'provinceWaterType',
    10241: 'constructbuilding',
    10242: 'projectionType',
    10243: 'pulsating',
    10244: 'additative',
    10245: 'expanding',
    10246: 'pulseLowest',
    10247: 'pulseSpeed',
    10248: 'spin',
    10249: 'fadeout',
    10250: 'mapRenderingOptions',
    10251: 'renderTrees',
    10252: 'bookmark',
    10253: 'selectbookmark',
    10254: 'clearbookmark',
    10255: 'loadgame',
    10256: 'loadgamestart',
    10257: 'lastplayer',
    10258: 'lasthost',
    10259: 'serveradress',
    10260: 'resetgame',
    10261: 'setdifficulty',
    10262: 'outliner',
    10263: 'confirm',
    10264: 'rotatingMeshType',
    10265: 'draw_terrain',
    10266: 'draw_water',
    10267: 'draw_borders',
    10268: 'draw_trees',
    10269: 'draw_rivers',
    10270: 'draw_postfx',
    10271: 'draw_sky',
    10272: 'draw_bloom',
    10273: 'draw_tooltips',
    10274: 'draw_hires_terrain',
    10275: 'draw_citysprawl',
    10276: 'draw_shadows',
    10277: 'hint',
    10278: 'disabled_hints',
    10279: 'outliner_open',
    10280: 'windowmovetime',
    10281: 'radialstaytime',
    10285: 'hints',
    10286: 'covert',
    10287: 'access',
    10288: 'selection_group_command',
    10289: 'selection_groups',
    10290: 'disabled_gui_object',
    10291: 'provinces',
    10292: 'max_provinces',
    10293: 'definitions',
    10294: 'maptype',
    10295: 'testmap',
    10296: 'history',
    10297: 'base_tax',
    10298: 'culture',
    10299: 'primary_culture',
    10300: 'accepted_culture',
    10301: 'allowed_conversion',
    10302: 'religion',
    10303: 'manpower',
    10304: 'monarch',
    10305: 'owner',
    10306: 'controller',
    10307: 'province',
    10308: 'conquercommand',
    10309: 'base_price',
    10310: 'max_demand',
    10311: 'min_demand',
    10312: 'trade_goods',
    10313: 'goldtype',
    10314: 'plantation',
    10315: 'yes',
    10316: 'no',
    10317: 'date',
    10318: 'capital',
    10319: 'citysize',
    10320: 'prerequisites',
    10321: 'not_if_x_exists',
    10322: 'building',
    10323: 'leader_names',
    10324: 'monarch_names',
    10325: 'core',
    10326: 'cost',
    10327: 'build_cost',
    10328: 'revolt_risk',
    10329: 'minimum_revolt_risk',
    10330: 'local_revolt_risk',
    10331: 'global_revolt_risk',
    10332: 'terrain',
    10333: 'terrain_definition',
    10334: 'movement_cost',
    10335: 'left_specific',
    10336: 'right_specific',
    10337: 'average_year',
    10338: 'technology',
    10339: 'technology_group',
    10340: 'tables',
    10341: 'groups',
    10342: 'government',
    10343: 'minimum_policy',
    10344: 'maximum_policy',
    10345: 'discovery_dates',
    10346: 'discovered_by',
    10347: 'allowed_idea_groups',
    10348: 'enroute',
    10349: 'once',
    10350: 'success',
    10351: 'level',
    10352: 'location',
    10353: 'trade',
    10354: 'stagnated',
    10355: 'trade_efficiency',
    10356: 'production_efficiency',
    10357: 'ledger',
    10358: 'treasury',
    10359: 'current_income',
    10360: 'distribution',
    10361: 'lastmonthincome',
    10362: 'lastmonthexpense',
    10363: 'lastmonthincometable',
    10364: 'lastmonthexpensetable',
    10365: 'lastyearincome',
    10366: 'lastyearexpense',
    10367: 'income',
    10368: 'expense',
    10369: 'thismonthincome',
    10370: 'thismonthexpense',
    10371: 'local_tax_modifier',
    10372: 'global_tax_modifier',
    10373: 'tax_income',
    10374: 'stability',
    10375: 'stability_cost_modifier',
    10376: 'inflation',
    10377: 'inflation_reduction',
    10378: 'inflation_reduction_local',
    10379: 'enable',
    10380: 'maneuver',
    10381: 'offensive_morale',
    10382: 'defensive_morale',
    10383: 'offensive_fire',
    10384: 'defensive_fire',
    10385: 'offensive_shock',
    10386: 'defensive_shock',
    10387: 'hull_size',
    10388: 'base_cannons',
    10389: 'sail_speed',
    10390: 'take_bank_loan',
    10391: 'offer_loan',
    10392: 'cancel_loan',
    10393: 'extend_loan',
    10394: 'pay_loan',
    10395: 'accept_loan',
    10396: 'decline_loan',
    10397: 'country',
    10398: 'altitude',
    10399: 'heightmap',
    10400: 'army',
    10401: 'navy',
    10402: 'regiment',
    10403: 'ship',
    10404: 'home',
    10405: 'move_order',
    10406: 'unit',
    10407: 'movement_progress',
    10408: 'morale',
    10409: 'strength',
    10410: 'DIP',
    10411: 'MIL',
    10412: 'ADM',
    10413: 'loan',
    10414: 'interest',
    10415: 'lender',
    10416: 'expiry_date',
    10417: 'cancelled_loans',
    10418: 'cancel_movement',
    10419: 'go_bankrupt',
    10420: 'last_bankrupt',
    10421: 'is_water',
    10422: 'siege',
    10423: 'fire',
    10424: 'shock',
    10425: 'manuever',
    10426: 'leader',
    10427: 'admiral',
    10428: 'explorer',
    10429: 'conquistador',
    10430: 'general',
    10431: 'has_texture',
    10432: 'activation',
    10433: 'create_leader',
    10434: 'spies',
    10435: 'global_trade_power',
    10436: 'global_foreign_trade_power',
    10437: 'global_own_trade_power',
    10438: 'colony_construction',
    10439: 'building_construction',
    10440: 'military_construction',
    10441: 'missionary_construction',
    10442: 'send_colonist',
    10443: 'send_missionary',
    10444: 'colonist_placement_chance',
    10445: 'local_colonist_placement_chance',
    10446: 'missionary_cost',
    10447: 'missionary_placement_chance',
    10448: 'local_missionary_cost',
    10449: 'local_missionary_placement_chance',
    10450: 'native_size',
    10451: 'native_ferocity',
    10452: 'native_hostileness',
    10453: 'population_growth',
    10454: 'daily_tick',
    10455: 'sea_starts',
    10456: 'skill',
    10457: 'advisor',
    10458: 'active_advisors',
    10459: 'increase_game_speed',
    10460: 'decrease_game_speed',
    10461: 'alliance',
    10462: 'guarantee',
    10463: 'royal_marriage',
    10464: 'union',
    10465: 'vassal',
    10466: 'first',
    10467: 'second',
    10468: 'start_date',
    10469: 'end_date',
    10470: 'tree',
    10471: 'tree_definition',
    10472: 'tree_density',
    10473: 'cancel',
    10474: 'city',
    10475: 'positions',
    10476: 'diplomacy',
    10477: 'casus_belli',
    10478: 'value',
    10479: 'graphical_culture',
    10480: 'add_attacker',
    10481: 'rem_attacker',
    10482: 'add_defender',
    10483: 'rem_defender',
    10484: 'battle',
    10485: 'attackers',
    10486: 'defenders',
    10487: 'active_war',
    10488: 'previous_war',
    10489: 'attacker',
    10490: 'defender',
    10491: 'result',
    10492: 'losses',
    10493: 'losses_type',
    10494: 'rivers',
    10495: 'idea',
    10496: 'policy',
    10497: 'take_wartaxes',
    10498: 'wartax',
    10499: 'land_morale',
    10500: 'naval_morale',
    10501: 'change_advisor',
    10503: 'global_manpower_modifier',
    10504: 'local_manpower_modifier',
    10505: 'global_manpower',
    10506: 'local_manpower',
    10507: 'land_forcelimit',
    10508: 'naval_forcelimit',
    10509: 'land_forcelimit_modifier',
    10510: 'naval_forcelimit_modifier',
    10511: 'infantry_cost',
    10512: 'cavalry_cost',
    10513: 'artillery_cost',
    10514: 'big_ship_cost',
    10515: 'heavy_ship_cost',
    10516: 'light_ship_cost',
    10517: 'galley_cost',
    10518: 'land_maintenance',
    10519: 'naval_maintenance',
    10520: 'change_maintenance',
    10521: 'change_investment',
    10522: 'combat',
    10523: 'phase',
    10524: 'dice',
    10525: 'land_combat',
    10526: 'naval_combat',
    10527: 'siege_combat',
    10528: 'sprite_level',
    10529: 'buildunit',
    10530: 'tolerance',
    10531: 'changetolerance',
    10532: 'retreat',
    10533: 'claimdefender',
    10534: 'convert',
    10535: 'attrition',
    10536: 'max_attrition',
    10537: 'supply_limit',
    10538: 'breach',
    10539: 'garrison',
    10540: 'assault',
    10541: 'blockade',
    10542: 'historical_ideas',
    10543: 'changefog',
    10544: 'last_control_change',
    10545: 'actor',
    10546: 'recipient',
    10547: 'rebel',
    10548: 'diplomaticactioncommand',
    10549: 'action',
    10550: 'trade_refusal',
    10551: 'military_access',
    10552: 'republican_name',
    10553: 'emperor',
    10554: 'is_emperor',
    10555: 'declarewar',
    10556: 'requestpeace',
    10557: 'allianceaction',
    10558: 'embargoaction',
    10559: 'annexationaction',
    10560: 'vassalaction',
    10561: 'guaranteeaction',
    10562: 'warningaction',
    10563: 'milaccess',
    10564: 'offermilaccess',
    10565: 'port_rotation',
    10566: 'opennegotiation',
    10567: 'insultaction',
    10568: 'giftaction',
    10569: 'claimaction',
    10570: 'last_war',
    10571: 'last_send_diplomat',
    10572: 'war_exhaustion_cost',
    10573: 'callaction',
    10574: 'versus',
    10575: 'continent',
    10576: 'overseas_income',
    10577: 'army_tradition',
    10578: 'navy_tradition',
    10579: 'army_tradition_decay',
    10580: 'navy_tradition_decay',
    10581: 'leader_fire',
    10582: 'leader_shock',
    10583: 'leader_siege',
    10584: 'change_prefered_unit',
    10585: 'may_explore',
    10586: 'convert_ruler',
    10587: 'convert_heir',
    10588: 'leader_naval_manuever',
    10589: 'local_spy_defence',
    10590: 'global_spy_defence',
    10591: 'spy_offence',
    10592: 'trade_value',
    10593: 'trade_value_modifier',
    10594: 'global_trade_income_modifier',
    10595: 'fort_level',
    10596: 'blockade_efficiency',
    10597: 'luck',
    10598: 'trigger',
    10599: 'mean_time_to_happen',
    10600: 'modifier',
    10601: 'option',
    10602: 'ai_chance',
    10603: 'and',
    10604: 'or',
    10605: 'not',
    10606: 'factor',
    10607: 'months',
    10608: 'days',
    10609: 'years',
    10610: 'shield3dType',
    10611: 'max_manpower',
    10612: 'manpower_percentage',
    10613: 'number_of_loans',
    10614: 'is_bankrupt',
    10615: 'owns',
    10616: 'controls',
    10617: 'is_core',
    10618: 'has_discovered',
    10619: 'num_of_revolts',
    10620: 'revolt_percentage',
    10621: 'num_of_cities',
    10622: 'num_of_ports',
    10623: 'is_monarch_leader',
    10624: 'defender_of_faith',
    10625: 'num_of_trade_embargos',
    10626: 'num_of_allies',
    10627: 'num_of_royal_marriages',
    10628: 'num_of_vassals',
    10629: 'num_of_unions',
    10630: 'num_of_electors',
    10631: 'num_of_religion',
    10632: 'religion_group',
    10633: 'infantry_fraction',
    10634: 'cavalry_fraction',
    10635: 'artillery_fraction',
    10636: 'big_ship_fraction',
    10637: 'heavy_ship_fraction',
    10638: 'light_ship_fraction',
    10639: 'galley_fraction',
    10640: 'war',
    10641: 'createvassal',
    10642: 'from',
    10643: 'to',
    10644: 'add_idea',
    10645: 'remove_idea',
    10646: 'title',
    10647: 'desc',
    10648: 'select_event_option',
    10649: 'scope',
    10650: 'seed',
    10651: 'historical_units',
    10652: 'death_date',
    10653: 'ally',
    10654: 'exists',
    10655: 'culture_group',
    10656: 'send_spy',
    10657: 'prestige',
    10658: 'difficulty',
    10659: 'ship_names',
    10660: 'ship_recruit_speed',
    10661: 'regiment_recruit_speed',
    10662: 'previous',
    10663: 'is_religion_enabled',
    10664: 'infantry_fire',
    10665: 'cavalry_fire',
    10666: 'artillery_fire',
    10667: 'big_ship_fire',
    10668: 'heavy_ship_fire',
    10669: 'light_ship_fire',
    10670: 'galley_fire',
    10671: 'infantry_shock',
    10672: 'cavalry_shock',
    10673: 'artillery_shock',
    10674: 'big_ship_shock',
    10675: 'heavy_ship_shock',
    10676: 'light_ship_shock',
    10677: 'galley_shock',
    10678: 'messageclass',
    10679: 'log',
    10680: 'onmap',
    10681: 'popup',
    10682: 'needaccept',
    10683: 'prestige_from_land',
    10684: 'prestige_from_naval',
    10685: 'prestige_decay',
    10686: 'cb_on_religious_enemies',
    10687: 'cb_on_primitives',
    10688: 'cb_on_overseas',
    10689: 'any_empty_neighbor_province',
    10690: 'any_neighbor_province',
    10691: 'any_neighbor_country',
    10692: 'relation',
    10693: 'who',
    10694: 'this',
    10695: 'papacy',
    10696: 'cardinal',
    10697: 'bribe_cardinal',
    10698: 'is_colony',
    10699: 'has_country_flag',
    10700: 'flags',
    10701: 'disband_unit',
    10702: 'disband_regiment',
    10703: 'merge_units',
    10704: 'reinforce',
    10705: 'transfer_subunit',
    10706: 'seize_colony',
    10707: 'burn_colony',
    10708: 'attack_natives',
    10709: 'sub_unit',
    10710: 'set_controller',
    10711: 'clear_all_controllers',
    10713: 'create_unit',
    10714: 'manufactory',
    10715: 'sethistoricaldate',
    10716: 'startgame',
    10717: 'quit',
    10718: 'terms',
    10719: 'demand',
    10720: 'releasevassal',
    10721: 'rename_unit',
    10722: 'rename_sub_unit',
    10723: 'front',
    10724: 'back',
    10725: 'reserves',
    10726: 'addplayer',
    10727: 'other',
    10728: 'positioning',
    10729: 'annex',
    10730: 'playerconnected',
    10731: 'economy',
    10732: 'military',
    10733: 'count',
    10734: 'setrandom',
    10735: 'pausegame',
    10736: 'assign_leader',
    10737: 'staging_province',
    10738: 'invasion',
    10739: 'client_only',
    10740: 'clear',
    10741: 'transport_fraction',
    10742: 'transport_cost',
    10743: 'transport_fire',
    10744: 'transport_shock',
    10745: 'owned_by',
    10746: 'garrison_growth',
    10747: 'has_province_flag',
    10748: 'adjacencies',
    10749: 'better',
    10750: 'create_succession_war',
    10751: 'succession',
    10752: 'regent',
    10753: 'capital_scope',
    10754: 'warning',
    10755: 'has_building',
    10756: 'change_manpower',
    10757: 'tag',
    10758: 'knows_country',
    10759: 'monthly_income',
    10760: 'total_ideas',
    10761: 'free_ideas',
    10762: 'secede_province',
    10763: 'mercenary',
    10764: 'inland_sea',
    10765: 'limit',
    10766: 'any_country',
    10767: 'random_owned',
    10768: 'neighbour',
    10769: 'regency',
    10770: 'city_nudge',
    10771: 'manufactory_nudge',
    10772: 'trade_nudge',
    10773: 'total',
    10774: 'text_position',
    10775: 'text_rotation',
    10776: 'female',
    10777: 'text_scale',
    10778: 'spies_cost',
    10779: 'advisor_cost',
    10780: 'boost',
    10781: 'tropical',
    10782: 'mild_winter',
    10783: 'normal_winter',
    10784: 'severe_winter',
    10785: 'climate',
    10786: 'winter',
    10787: 'autosave',
    10788: 'offerloan',
    10789: 'warsubsidy',
    10790: 'color1',
    10791: 'color2',
    10792: 'color3',
    10793: 'sellprov',
    10794: 'subsidies',
    10795: 'sea_zone',
    10796: 'has_province_modifier',
    10797: 'has_country_modifier',
    10798: 'last_command_date',
    10799: 'previous_monarch',
    10800: 'discovery_religion_dates',
    10801: 'units_in_province',
    10802: 'galleys_in_province',
    10803: 'war_with',
    10804: 'unit_in_battle',
    10805: 'unit_in_siege',
    10806: 'infantry_in_province',
    10807: 'unit_has_leader',
    10808: 'player',
    10809: 'is_papal_controller',
    10810: 'estimated_monthly_income',
    10811: 'doautosave',
    10812: 'at_sea',
    10813: 'arrow_state',
    10815: 'replace',
    10816: 'extend',
    10817: 'reduced_naval_attrition',
    10818: 'technology_cost',
    10819: 'plantation_demand',
    10820: 'simpleWater',
    10821: 'has_siege',
    10822: 'ai_will_do',
    10823: 'pure_revolt_risk',
    10824: 'global_ship_recruit_speed',
    10825: 'global_regiment_recruit_speed',
    10826: 'global_colonial_growth',
    10827: 'local_colonial_growth',
    10828: 'check_variable',
    10829: 'variables',
    10830: 'region',
    10831: 'abort',
    10832: 'revolt',
    10833: 'empty',
    10834: 'is_rival',
    10835: 'is_threat',
    10836: 'is_mission_country',
    10837: 'is_mission_province',
    10838: 'is_subject',
    10839: 'defensiveness',
    10840: 'immediate',
    10841: 'num_of_cardinals',
    10842: 'war_countries',
    10843: 'enemy_provinces',
    10844: 'is_blockaded',
    10845: 'local_defensiveness',
    10846: 'cot_value',
    10847: 'supply',
    10848: 'detach_merc',
    10849: 'detach_siege',
    10850: 'army_names',
    10851: 'fleet_names',
    10852: 'global_ship_cost',
    10853: 'global_regiment_cost',
    10854: 'patrol',
    10855: 'local_tariffs',
    10856: 'global_tariffs',
    10857: 'diplomatic_reputation',
    10858: 'toggle',
    10859: 'sea_repair',
    10860: 'mercenary_cost',
    10861: 'detach_blockade',
    10862: 'any_center_of_trade',
    10863: 'ai_index',
    10864: 'tariff_efficiency',
    10865: 'on_left',
    10866: 'on_right',
    10867: 'friend',
    10868: 'war_score',
    10869: 'has_sphere',
    10870: 'any_sphere',
    10871: 'military_tactics',
    10872: 'abandon_merchants',
    10873: 'hre_size',
    10874: 'can_not_build_colonies',
    10875: 'can_not_build_buildings',
    10876: 'can_not_build_missionaries',
    10877: 'can_not_declare_war',
    10878: 'can_not_send_merchants',
    10879: 'rule',
    10880: 'faction',
    10881: 'influence',
    10882: 'cap_force_first',
    10883: 'capped_by_forcelimit',
    10884: 'has_factions',
    10885: 'has_faction',
    10886: 'faction_influence',
    10887: 'is_top_faction',
    10888: 'old_influence',
    10889: 'possible',
    10890: 'happened',
    10891: 'hidden_flags',
    10892: 'has_leader_with',
    10893: 'achievement',
    10894: 'nomad',
    10895: 'num_foreign_colonists',
    10896: 'foreign_colonists',
    10897: 'tech_difference',
    10898: 'trade_range',
    10899: 'control',
    10900: 'modifier_province_owner_trade_chance',
    10901: 'placed_merchants_in_cot',
    10902: 'any_core_province',
    10904: 'production_leader',
    10905: 'trading_bonus',
    10906: 'trading_part',
    10907: 'faction_in_power',
    10908: 'integrationaction',
    10909: 'num_trade_leader',
    10910: 'trade_range_modifier',
    10911: 'horde_war',
    10912: 'traded_bonus',
    10913: 'hunt_rebel',
    10914: 'split_unit',
    10915: 'multiplier',
    10916: 'opinion',
    10917: 'prison_reason',
    10918: 'revoke_reason',
    10919: 'incoming',
    10920: 'outgoing',
    10921: 'members',
    10922: 'lakes',
    10923: 'attachments',
    10924: 'detach_unit',
    10925: 'attach_unit',
    10926: 'scaled_badboy',
    10927: 'ambient_object',
    10928: 'time_duration',
    10929: 'max_visible',
    10930: 'powers',
    10931: 'spend_power_command',
    10932: 'power',
    10933: 'monarch_power',
    10934: 'bonus',
    10935: 'seasons',
    10936: 'spring',
    10937: 'summer',
    10938: 'autumn',
    10939: 'hsv_north',
    10940: 'hsv_center',
    10941: 'hsv_south',
    10942: 'colorbalance_north',
    10943: 'colorbalance_center',
    10944: 'colorbalance_south',
    10945: 'add_idea_group',
    10946: 'remove_idea_group',
    10947: 'idea_group',
    10948: 'cancel_merchant',
    10949: 'infantry_power',
    10950: 'cavalry_power',
    10951: 'artillery_power',
    10952: 'big_ship_power',
    10953: 'heavy_ship_power',
    10954: 'light_ship_power',
    10955: 'galley_power',
    10956: 'transport_power',
    10957: 'free',
    10958: 'leader_land_manuever',
    10959: 'manpower_recovery_speed',
    10960: 'auto_explore_adjacent_to_colony',
    10961: 'reduced_native_attacks',
    10962: 'hostile_attrition',
    10963: 'core_creation',
    10964: 'enemy_core_creation',
    10965: 'free_leader_pool',
    10966: 'envoy',
    10967: 'may_force_march',
    10968: 'force_march',
    10969: 'may_reduce_inflation',
    10970: 'reduced_stab_impacts',
    10971: 'heir_chance',
    10972: 'imperial_authority',
    10973: 'tree_winter',
    10974: 'tree_winter2',
    10975: 'tree_spring',
    10976: 'tree_spring2',
    10977: 'tree_summer',
    10978: 'tree_summer2',
    10979: 'tree_autumn',
    10980: 'tree_autumn2',
    10981: 'diplomatic_upkeep',
    10982: 'unjustified_demands',
    10983: 'extra_manpower_at_religious_war',
    10984: 'possible_mercenaries',
    10985: 'rival_command',
    10986: 'enemy',
    10987: 'trade_prov',
    10988: 'demo',
    10991: 'detach_damaged',
    10992: 'has_patriarchs',
    10993: 'fabricate_claim',
    10994: 'idea_claim_colonies',
    10995: 'relations_decay_of_me',
    10996: 'may_sabotage_reputation',
    10997: 'may_sow_discontent',
    10998: 'may_infiltrate_administration',
    10999: 'fraction',
    11000: 'uses_piety',
    11001: 'global_prov_trade_power_modifier',
    11002: 'idea_cost',
    11003: 'collector_power',
    11004: 'actual_added_value',
    11005: 'fire_only_once',
    11006: 'fired_events',
    11007: 'inflation_history',
    11008: 'arranged',
    11009: 'allow_vassal_war',
    11010: 'allow_convert',
    11011: 'added_history',
    11012: 'vassal_income',
    11013: 'pirates',
    11014: 'trade_goods_size',
    11015: 'create_union',
    11016: 'progress',
    11017: 'cancel_colonist',
    11018: 'attach_leader',
    11019: 'ship_power',
    11020: 'permanent',
    11021: 'advisor_pool',
    11022: 'estimated_loan',
    11023: 'gfx_type',
    11024: 'culture_province',
    11025: 'culture_owner',
    11026: 'second_graphical_culture',
    11027: 'diplomatic_power_cache',
    11028: 'member',
    11029: 'reform_level',
    11030: 'enact_imperial_reform',
    11031: 'hre_inheritable',
    11032: 'force_pow2_textures',
    11033: 'stacking',
    11034: 'add_province_to_hre',
    11035: 'remove_province_from_hre',
    11036: 'grant_electorate',
    11037: 'westernisation',
    11038: 'perform_westernisation',
    11039: 'misguided_heretic',
    11040: 'value_added_outgoing',
    11041: 'no_opinion_hit',
    11042: 'cancel_diplomat',
    11043: 'no_cost_for_reinforcing',
    11044: 'global_garrison_growth',
    11045: 'toggle_force_march',
    11046: 'rivals_rivals',
    11047: 'score',
    11048: 'threats_rivals',
    11049: 'num_of_non_rival_trade_embargos',
    11050: 'score_statistics',
    11051: 'historical_score',
    11052: 'province_trade_power_modifier',
    11053: 'decay',
    11054: 'combat_sound_random',
    11055: 'sound_type',
    11056: 'under_construction_queued',
    11057: 'connected_icons',
    11058: 'fixed',
    11059: 'allow_leader_change',
    11060: 'perform_shattered_retreat',
    11061: 'always_visible',
    11062: 'preferred_religion',
    11063: 'draw_reflections',
    11064: 'draw_ambient_objects',
    11065: 'moving_units',
    11066: 'arctic',
    11067: 'arid',
    11068: 'top_provinces',
    11069: 'top_provinces_values',
    11070: 'top_power',
    11071: 'top_power_values',
    11072: 'colonist_time',
    11073: 'local_colonist_time',
    11074: 'trade_steering',
    11075: 'fabricate_claims_cost',
    11076: 'rebel_support_efficiency',
    11077: 'discovered_relations_impact',
    11078: 'infiltrate_administraton',
    11079: 'relations_decay',
    11080: 'local_missionary_strength',
    11081: 'global_missionary_strength',
    11082: 'adm_power',
    11083: 'dip_power',
    11084: 'mil_power',
    11085: 'hidden_trigger',
    11086: 'is_year',
    11087: 'is_month',
    11088: 'years_of_income',
    11089: 'legitimacy',
    11090: 'has_wartaxes',
    11091: 'is_at_war',
    11092: 'war_with_nomads',
    11093: 'always',
    11094: 'num_of_loans',
    11095: 'is_revolution_target',
    11096: 'revolution_target_exists',
    11097: 'is_elector',
    11098: 'core_percentage',
    11099: 'nationalism',
    11100: 'num_of_total_ports',
    11101: 'num_of_generals',
    11102: 'num_of_admirals',
    11103: 'num_of_conquistadors',
    11104: 'num_of_explorers',
    11105: 'is_heir_leader',
    11106: 'is_defender_of_faith',
    11107: 'num_of_trade_rights',
    11108: 'has_port',
    11109: 'is_empty',
    11110: 'has_cot',
    11111: 'is_looted',
    11112: 'has_missionary',
    11113: 'has_colonist',
    11114: 'is_female',
    11115: 'controlled_by',
    11116: 'dominant_culture',
    11117: 'dominant_religion',
    11118: 'tolerance_to_this',
    11119: 'is_force_converted',
    11120: 'army_size',
    11121: 'navy_size',
    11122: 'num_of_infantry',
    11123: 'num_of_cavalry',
    11124: 'num_of_artillery',
    11125: 'num_of_big_ship',
    11126: 'num_of_heavy_ship',
    11127: 'num_of_light_ship',
    11128: 'num_of_galley',
    11129: 'num_of_transport',
    11130: 'has_idea',
    11131: 'likely_rebels',
    11132: 'any_province',
    11133: 'any_owned_province',
    11134: 'any_heretic_province',
    11135: 'religion_years',
    11136: 'unit_type',
    11137: 'is_wasteland',
    11138: 'is_overseas',
    11139: 'last_mission',
    11140: 'last_minor_mission',
    11141: 'last_major_mission',
    11142: 'has_global_flag',
    11143: 'had_country_flag',
    11144: 'had_province_flag',
    11145: 'had_global_flag',
    11146: 'has_hre_member_modifier',
    11147: 'has_hre_emperor_modifier',
    11148: 'can_spawn_rebels',
    11149: 'any_rival_country',
    11150: 'any_enemy_country',
    11151: 'any_known_country',
    11152: 'any_ally',
    11153: 'any_local_enemy',
    11154: 'colonysize',
    11155: 'is_city',
    11156: 'is_part_of_hre',
    11157: 'temp_claim',
    11158: 'has_casus_belli_against',
    11159: 'core_claim',
    11160: 'culture_group_claim',
    11161: 'religion_group_claim',
    11162: 'border_friction_claim',
    11163: 'colony_claim',
    11164: 'succession_claim',
    11165: 'imperial_influence',
    11166: 'papal_influence',
    11167: 'num_of_diplomats',
    11168: 'num_of_missionaries',
    11169: 'num_of_colonists',
    11170: 'num_of_merchants',
    11171: 'num_of_total_ideas',
    11172: 'num_of_free_ideas',
    11173: 'is_neighbor_of',
    11174: 'has_regency',
    11175: 'papacy_active',
    11176: 'has_heir',
    11177: 'has_female_heir',
    11178: 'heir_claim',
    11179: 'heir_age',
    11180: 'is_capital',
    11181: 'preferred_emperor',
    11182: 'previous_owner',
    11183: 'is_enemy',
    11184: 'truce_with',
    11185: 'primitives',
    11186: 'is_tribal',
    11187: 'is_crusade_target',
    11188: 'dynasty',
    11189: 'hre_majority',
    11190: 'navy_size_percentage',
    11191: 'army_size_percentage',
    11192: 'max_manpower_greater_than',
    11193: 'overseas_provinces_percentage',
    11194: 'num_of_placed_merchants',
    11195: 'trade_income_percentage',
    11196: 'gold_income_percentage',
    11197: 'num_of_total_merchants',
    11198: 'at_war_with_religious_enemy',
    11199: 'has_border_with_religious_enemy',
    11200: 'has_empty_adjacent_province',
    11201: 'has_ruler',
    11202: 'has_leader',
    11203: 'ai',
    11204: 'num_of_colonies',
    11205: 'can_create_vassals',
    11206: 'is_possible_vassal',
    11207: 'province_id',
    11208: 'vassal_of',
    11209: 'overlord_of',
    11210: 'in_sphere_of',
    11211: 'alliance_with',
    11212: 'marriage_with',
    11213: 'trade_embargo_by',
    11214: 'trade_embargoing',
    11215: 'junior_union_with',
    11216: 'senior_union_with',
    11217: 'has_advisor',
    11218: 'is_excommunicated',
    11219: 'is_lesser_in_union',
    11220: 'active_minor_mission',
    11221: 'active_major_mission',
    11222: 'has_owner_religion',
    11223: 'has_owner_culture',
    11224: 'any_elector',
    11225: 'any_core_country',
    11226: 'has_removed_fow',
    11227: 'is_colonial',
    11228: 'months_since_defection',
    11229: 'is_nomad',
    11230: 'cavalry_in_province',
    11231: 'artillery_in_province',
    11232: 'big_ships_in_province',
    11233: 'heavy_ships_in_province',
    11234: 'light_ships_in_province',
    11235: 'transports_in_province',
    11236: 'advisor_exists',
    11237: 'has_idea_group',
    11238: 'full_idea_group',
    11239: 'religious_unity',
    11240: 'is_claim',
    11241: 'has_claim',
    11242: 'is_any_heresy_enabled',
    11243: 'patriarch_authority',
    11244: 'has_opinion',
    11245: 'reverse_has_opinion',
    11246: 'has_opinion_diff',
    11247: 'reverse_has_opinion_diff',
    11248: 'has_opinion_modifier',
    11249: 'reverse_has_opinion_modifier',
    11250: 'overextension_percentage',
    11251: 'any_trade_node',
    11252: 'any_active_trade_node',
    11253: 'strongest_trade_power',
    11254: 'most_province_trade_power',
    11255: 'is_strongest_trade_power',
    11256: 'has_most_province_trade_power',
    11257: 'num_of_owned_provinces_with',
    11258: 'is_subject_of',
    11259: 'is_sea',
    11260: 'piety',
    11261: 'mercantilism',
    11262: 'has_ruler_modifier',
    11263: 'personality',
    11264: 'months_since_last_owner_change',
    11265: 'months_of_ruling',
    11266: 'is_in_coalition',
    11267: 'leads_coalition',
    11268: 'any_coalition_member',
    11269: 'republican_tradition',
    11270: 'original_recipient_only',
    11271: 'is_advisor_employed',
    11272: 'capital_trade_node',
    11273: 'has_trader',
    11274: 'has_spawned_rebels',
    11275: 'has_not_spawned_rebels',
    11276: 'has_trade_modifier',
    11277: 'reform_desire',
    11278: 'can_release',
    11279: 'can_build',
    11280: 'is_westernising',
    11281: 'all_neighbor_province',
    11282: 'all_empty_neighbor_province',
    11283: 'all_owned_province',
    11284: 'all_heretic_province',
    11285: 'all_neighbor_country',
    11286: 'all_known_country',
    11287: 'all_country',
    11288: 'all_ally',
    11289: 'all_rival_country',
    11290: 'all_enemy_country',
    11291: 'all_local_enemy',
    11292: 'all_elector',
    11293: 'all_core_country',
    11294: 'all_trade_node',
    11295: 'all_active_trade_node',
    11296: 'all_coalition_member',
    11297: 'all_core_province',
    11298: 'is_vassal',
    11299: 'weaken',
    11300: 'fortify',
    11301: 'ignore',
    11302: 'attitude',
    11303: 'distance',
    11304: 'capital_distance',
    11305: 'border_distance',
    11306: 'max_vassal',
    11307: 'provinces_on_continent',
    11308: 'provinces_on_capital_continent_of',
    11309: 'army_balance',
    11310: 'navy_balance',
    11311: 'military_strength',
    11312: 'naval_strength',
    11313: 'locked',
    11314: 'any_target_province',
    11315: 'all_target_province',
    11316: 'warn',
    11317: 'num_of_trading_bonuses',
    11318: 'num_of_mercenaries',
    11319: 'has_casus_belli',
    11320: 'allows_female_emperor',
    11321: 'any_trade_node_member_province',
    11322: 'any_trade_node_member_country',
    11323: 'all_trade_node_member_province',
    11324: 'all_trade_node_member_country',
    11325: 'coalition_target',
    11326: 'is_imperial_ban_allowed',
    11327: 'ai_mission',
    11328: 'owns_or_vassal_of',
    11329: 'defensive_war_with',
    11330: 'offensive_war_with',
    11331: 'will_back_next_reform',
    11332: 'has_construction',
    11333: 'owns_core_province',
    11334: 'has_truce',
    11335: 'has_owner_accepted_culture',
    11336: 'sieged_by',
    11337: 'all_province',
    11338: 'tutorial',
    11339: 'window',
    11340: 'tutorial_window',
    11341: 'tutorial_window_position',
    11342: 'tutorial_window_size',
    11343: 'page',
    11344: 'window_position',
    11345: 'window_size',
    11346: 'exclusive',
    11347: 'close_window',
    11348: 'text1',
    11349: 'text2',
    11350: 'text3',
    11351: 'text4',
    11352: 'text5',
    11353: 'text6',
    11354: 'text7',
    11355: 'text8',
    11356: 'text9',
    11357: 'text10',
    11358: 'select_province',
    11359: 'select_army',
    11360: 'select_navy',
    11361: 'goto',
    11362: 'mapmode',
    11363: 'zoom',
    11364: 'panel',
    11365: 'domestic_panel',
    11366: 'province_panel',
    11367: 'message_log',
    11368: 'select_units',
    11369: 'save_game',
    11370: 'interactive',
    11371: 'args',
    11372: 'close_on',
    11373: 'anchor',
    11374: 'open_window',
    11375: 'pauseable',
    11376: 'lock_zoom',
    11377: 'lock_camera_to_box',
    11378: 'allow_select_province',
    11379: 'allow_select_army',
    11380: 'allow_select_navy',
    11381: 'pause',
    11382: 'reset_lock_box',
    11383: 'keep_window_open',
    11384: 'keep_window_closed',
    11385: 'disband_player_units',
    11386: 'max_speed',
    11387: 'clear_navy_construction',
    11388: 'clear_army_construction',
    11389: 'clear_building_construction',
    11390: 'hide_on_parent_hide',
    11391: 'unit_not_exist',
    11392: 'embarked',
    11393: 'navy_construction',
    11394: 'army_construction',
    11395: 'zoom_in',
    11396: 'zoom_out',
    11397: 'button',
    11398: 'extra_window',
    11399: 'instant_build',
    11400: 'instant_colony',
    11401: 'attached_army',
    11402: 'has_office',
    11403: 'has_transit',
    11404: 'trade_patrol',
    11405: 'pausepopup',
    11406: 'discovercommand',
    11407: 'placed_merchants',
    11408: 'total_merchants',
    11409: 'inauguration',
    11410: 'last_target',
    11411: 'current_route_target',
    11412: 'has_capital',
    11413: 'number_of_colonies',
    11414: 'vassal_revolt',
    11415: 'random_threat_country',
    11416: 'discipline',
    11417: 'setgameplayoptions',
    11418: 'settings',
    11419: 'gameplaysettings',
    11420: 'move_capital',
    11421: 'auto_send_merchants',
    11422: 'dismantleHRE',
    11423: 'no_religion_penalty',
    11424: 'land_attrition',
    11425: 'naval_attrition',
    11426: 'cb_on_government_enemies',
    11427: 'from_country',
    11428: 'from_province',
    11429: 'to_country',
    11430: 'to_province',
    11431: 'is_triggered_only',
    11432: 'which',
    11433: 'heretic',
    11434: 'local_enemy',
    11435: 'revolutionary_war',
    11436: 'revolution_target',
    11437: 'current',
    11438: 'human',
    11439: 'consolidate',
    11440: 'cancel_unit',
    11441: 'reinforce_speed',
    11442: 'lake',
    11443: 'create_cot',
    11444: 'destroy_cot',
    11445: 'advisor_id',
    11446: 'overlord',
    11447: 'start_level',
    11448: 'potential',
    11449: 'allow',
    11450: 'country_decisions',
    11451: 'religion_decisions',
    11452: 'execute_decision_command',
    11453: 'decision',
    11454: 'tolerance_own',
    11455: 'tolerance_heretic',
    11456: 'tolerance_heathen',
    11457: 'spawn_chance',
    11458: 'movement_evaluation',
    11459: 'siege_won_trigger',
    11460: 'siege_won_effect',
    11461: 'demands_accepted_effect',
    11462: 'demands_enforced_effect',
    11463: 'rebel_faction',
    11464: 'execute_rebel_acceptance_command',
    11465: 'area',
    11466: 'nation',
    11467: 'all',
    11468: 'republic',
    11469: 'monarchy',
    11470: 'theocracy',
    11471: 'any',
    11472: 'defection',
    11473: 'resilient',
    11474: 'independence',
    11475: 'defect_delay',
    11476: 'anti',
    11477: 'call_crusade_action',
    11478: 'excommunicate_action',
    11479: 'crusade_target',
    11480: 'crusade_start',
    11481: 'excommunicated',
    11482: 'last_excom',
    11483: 'last_bribe',
    11484: 'nation_culture',
    11485: 'nation_religion',
    11486: 'our_provinces',
    11487: 'neighbor_provinces',
    11488: 'neighbor_countries',
    11489: 'parent_scope',
    11490: 'trust',
    11491: 'distrust',
    11492: 'primary',
    11493: 'colonial',
    11494: 'balanced',
    11495: 'hre_interest',
    11496: 'papacy_interest',
    11497: 'colonize_prov',
    11498: 'conquer_prov',
    11499: 'cot_prov',
    11500: 'building_prov',
    11501: 'explore_prov',
    11502: 'threat',
    11503: 'protect',
    11504: 'antagonize',
    11505: 'befriend',
    11506: 'convert_prov',
    11507: 'initialized',
    11508: 'rival_countries',
    11509: 'threat_countries',
    11510: 'any_threat_country',
    11511: 'rival',
    11512: 'empty_provinces',
    11513: 'sea_zones',
    11514: 'all_cots',
    11515: 'colonial_maintenance',
    11516: 'change_colonial_maintenance',
    11517: 'disband_on_leader_death',
    11518: 'reinforcing',
    11519: 'elector_countries',
    11520: 'smart',
    11521: 'total_num_of_ports',
    11522: 'last_minor_mission_cancel',
    11523: 'last_major_mission_cancel',
    11524: 'last_minor_mission_pick',
    11525: 'last_major_mission_pick',
    11526: 'cancel_minor_mission_command',
    11527: 'cancel_major_mission_command',
    11528: 'select_major_mission_command',
    11529: 'last_election',
    11530: 'scorch_earth',
    11531: 'slider_locks',
    11532: 'right_locked',
    11533: 'left_locked',
    11534: 'missionary_maintenance',
    11535: 'change_missionary_maintenance',
    11536: 'last_hre_vote',
    11537: 'cast_electoral_vote_command',
    11538: 'major',
    11539: 'minor',
    11540: 'last_rebel_acceptance',
    11541: 'can_negotiate_trigger',
    11542: 'historical_friend',
    11543: 'historical_friends',
    11544: 'historical_rival',
    11545: 'historical_rivals',
    11546: 'hire_date',
    11547: 'can_enforce_trigger',
    11548: 'ai_seed',
    11549: 'ai_hard_strategy',
    11550: 'valid_for_new_country',
    11551: 'changed_tag_from',
    11552: 'change_province_capital_name',
    11553: 'old_emperor',
    11554: 'unit_transfer',
    11555: 'impassable',
    11556: 'peace_options',
    11557: 'po_demand_provinces',
    11558: 'po_revoke_cores',
    11559: 'po_release_vassals',
    11560: 'po_release_annexed',
    11561: 'po_change_religion',
    11562: 'po_form_personal_union',
    11563: 'po_gold',
    11564: 'po_become_vassal',
    11565: 'po_concede_defeat',
    11566: 'po_annul_treaties',
    11567: 'po_change_government',
    11568: 'allowed_provinces',
    11569: 'badboy_factor',
    11570: 'empire',
    11571: 'war_name',
    11572: 'crusade_name',
    11573: 'prestige_factor',
    11574: 'concede',
    11575: 'peace_cost_factor',
    11576: 'sphere',
    11577: 'sphereaction',
    11578: 'infamy',
    11579: 'abort_effect',
    11580: 'this_remove_casus_belli',
    11581: 'in_sphere',
    11582: 'original_attacker',
    11583: 'original_defender',
    11584: 'dynasty_names',
    11585: 'heir',
    11586: 'birth_date',
    11587: 'claim',
    11588: 'monarch_name',
    11589: 'mutual',
    11590: 'imperial_relations_action',
    11591: 'imperial_ban_action',
    11592: 'religious_unity_action',
    11593: 'imperial_revision_action',
    11594: 'imperial_aid_action',
    11595: 'officials',
    11596: 'annul',
    11597: 'legal_monarch',
    11598: 'tribal',
    11599: 'hre_decisions',
    11600: 'move_focus',
    11601: 'last_focus_move',
    11602: 'flag',
    11603: 'naval_tradition_cost',
    11604: 'army_tradition_cost',
    11605: 'availability',
    11606: 'recruit_advisor',
    11607: 'member_modifier',
    11608: 'emperor_modifier',
    11609: 'hre_dismantled',
    11610: 'trade_wind_direction',
    11611: 'local_production_efficiency',
    11612: 'defender_date',
    11613: 'land_maintenance_modifier',
    11614: 'naval_maintenance_modifier',
    11615: 'categories',
    11616: 'random_events',
    11617: 'events',
    11618: 'commander',
    11619: 'prov_desc',
    11620: 'country_desc',
    11621: 'cav_to_inf_ratio',
    11622: 'revolt_trigger',
    11623: 'merc_maintenance_modifier',
    11624: 'text_height',
    11625: 'sea_text_alpha',
    11626: 'counter_distance',
    11627: 'defence',
    11628: 'province_flag_sprite',
    11629: 'region_sea',
    11630: 'border_heights',
    11631: 'terrain_sheet_heights',
    11632: 'border_cutoff',
    11633: 'building_position',
    11634: 'building_nudge',
    11635: 'building_rotation',
    11636: 'client_ping',
    11637: 'city_rotation',
    11638: 'manufactory_rotation',
    11639: 'finished_nudge',
    11640: 'internal',
    11641: 'external',
    11642: 'destroy_on_conquest',
    11643: 'one_per_country',
    11644: 'local_ship_cost',
    11645: 'local_ship_repair',
    11646: 'local_movement_speed',
    11647: 'local_regiment_cost',
    11649: 'destroybuilding',
    11650: 'active',
    11651: 'unitstatsBillboardType',
    11652: 'mask',
    11653: 'leave_hre',
    11654: 'slow_limit',
    11655: 'original',
    11656: 'safe',
    11657: 'avoid',
    11658: 'base',
    11659: 'unload_unit',
    11660: 'load_unit',
    11661: 'ai_importance',
    11662: 'precise_prestige',
    11663: 'spare_on_core',
    11664: 'hidden',
    11665: 'default',
    11666: 'interesting',
    11667: 'from_me',
    11668: 'to_me',
    11669: 'my',
    11670: 'interesting_countries',
    11671: 'msg_icontype',
    11672: 'root',
    11673: 'prev',
    11674: 'from_scope',
    11675: 'from_from_scope',
    11676: 'prev_scope',
    11677: 'root_scope',
    11678: 'song',
    11679: 'sound_effect',
    11680: 'trade_power',
    11681: 'province_trade_efficiency',
    11682: 'province_trade_power_value',
    11683: 'disabled_alerts',
    11684: 'tradeRouteType',
    11685: 'local_value',
    11686: 'retention',
    11687: 'steer_power',
    11688: 'pull_power',
    11689: 'retain_power',
    11690: 'highest_power',
    11691: 'max_power',
    11692: 'province_power',
    11693: 'power_fraction',
    11694: 'power_fraction_push',
    11695: 'money',
    11696: 'pauseai',
    11697: 'resumeai',
    11699: 'demands_description',
    11700: 'handle_action_negotiate',
    11701: 'handle_action_stability',
    11702: 'handle_action_build_core',
    11703: 'handle_action_send_missionary',
    11704: 'handle_action_change_culture',
    11705: 'steer_command',
    11706: 'last_at_sea',
    11707: 'trade_mission',
    11708: 'historical_idea_groups',
    11709: 'cancel_effect',
    11710: 'mission',
    11711: 'on_convert',
    11712: 'convert_to_religion',
    11713: 'invest_in_cardinal',
    11714: 'active_cardinals',
    11715: 'future_cardinals',
    11716: 'cardinal_age',
    11717: 'votes',
    11718: 'multiplayer_random_seed',
    11719: 'multiplayer_random_count',
    11720: 'yearly_decay',
    11721: 'namespace',
    11722: 'current_opinion',
    11723: 'delayed_event',
    11724: 'embargo_efficiency',
    11725: 'annexation',
    11726: 'hotjoin',
    11727: 'reopen_lobby',
    11728: 'startgame_from_ingamelobby',
    11729: 'ready_after_hotjoin',
    11730: 'resume_countdown',
    11731: 'combat_width',
    11732: 'is_attacker',
    11733: 'integration',
    11734: 'fleet_access',
    11735: 'offer_fleet_access',
    11736: 'under_construction',
    11737: 'total_count',
    11738: 'enforce_peace',
    11739: 'improve_relation',
    11740: 'infiltrate_administration',
    11741: 'sabotage_reputation',
    11742: 'support_rebels',
    11743: 'sow_discontent',
    11744: 'form_coalition',
    11745: 'coalition',
    11746: 'coalition_against_us',
    11747: 'ruler_modifier',
    11748: 'attacker_score',
    11749: 'defender_score',
    11750: 'war_goal',
    11751: 'take_colony',
    11752: 'take_core',
    11753: 'take_border',
    11754: 'take_province',
    11755: 'take_capital',
    11756: 'defend_capital',
    11757: 'defend_country',
    11758: 'maneuver_value',
    11759: 'retreat_shattered',
    11760: 'recover_army_morale_speed',
    11761: 'recover_navy_morale_speed',
    11762: 'removed_from_battle_this_day',
    11763: 'fromfromlist',
    11764: 'savegamecommand',
    11765: 'missionary_progress',
    11766: 'raid',
    11767: 'naval_superiority',
    11768: 'superiority',
    11769: 'take_region',
    11770: 'allow_annex',
    11771: 'dismiss_leader',
    11772: 'possible_provinces',
    11773: 'build_core_construction',
    11774: 'change_culture_construction',
    11775: 'return_core',
    11776: 'po_return_cores',
    11777: 'ready_status',
    11778: 'set_war_peace_command',
    11779: 'leader_may_demand_command',
    11780: 'po_revoke_elector',
    11781: 'revoke_elector',
    11782: 'elector_relation',
    11783: 'po_trade_power',
    11784: 'num_uncontested_cores',
    11785: 'transfer_trade_power',
    11787: 'demand_unlawful_territory_action',
    11788: 'custom_mapmodes',
    11789: 'check_sync_response_command',
    11790: 'check_sync_command',
    11791: 'cancel_building',
    11792: 'available_diplo_relations_cache',
    11793: 'exile_status',
    11794: 'exile',
    11795: 'has_changed',
    11796: 'initialized_attitudes',
    11797: 'military_rating',
    11798: 'last_dlcs',
    11799: 'last_strategy_index',
    11800: 'ironman',
    11801: 'last_mods',
    11802: 'target_provinces',
    11803: 'cancel_change_culture',
    11804: 'cancel_build_core',
    11805: 'file_version',
    11806: 'set_DLCs',
    11807: 'dlcs',
    11808: 'has_dlc',
    11809: 'is_connected_to_ship',
    11810: 'connect_to_ship_command',
    11811: 'do_connect_to_ship',
    11812: 'war_direction_quarter',
    11813: 'war_direction_year',
    11814: 'last_warscore_quarter',
    11815: 'last_warscore_year',
    11816: 'next_quarter_update',
    11817: 'next_year_update',
    11818: 'po_nodemand',
    11819: 'succeeded',
    11820: 'open',
    11821: 'closed',
    11822: 'lock_all_nations',
    11823: 'visible',
    11824: 'last_assault',
    11825: 'last_recalc_date',
    11826: 'end_when',
    11827: 'boot_time',
    11828: 'start_time',
    11829: 'end_time',
    11830: 'pause_with_no_player',
    11831: 'name_of_save',
    11832: 'saving_frequency',
    11833: 'MP_locked_countries',
    11834: 'stalled_years',
    11835: 'autosave_tocloud',
    11836: 'detach_subunit',
    11837: 'leave_page_effect',
    11838: 'country_modifiers',
    11839: 'province_modifiers',
    11840: 'player_ai_prefs_command',
    11841: 'start_wars',
    11842: 'opinion_cache',
    11843: 'keep_alliances',
    11844: 'quick_peace',
    11845: 'move_traders',
    11846: 'timeout',
    11847: 'alerts',
    11848: 'possible_mercenary',
    11849: 'allow_vassal_alliance',
    11850: 'po_independence',
    11851: 'allowed_countries',
    11852: 'debug_saves',
    11853: 'religions',
    11854: 'countries',
    11855: 'standalone_admin_settings',
    11856: 'change_player_admin_status',
    11857: 'num_of_admins',
    11858: 'admin_type',
    11859: 'admin',
    11860: 'everybody',
    11861: 'transfer_subunits',
    11862: 'delete_only_empty',
    11863: 'fow',
    11864: 'debug_current_ref_id',
    11865: 'cached_sum',
    11866: 'easy_country',
    11867: 'allowed_provinces_are_eligible',
    11868: 'annul_treaties',
    11869: 'may_support_rebels',
    11870: 'last_war_ended',
    11871: 'scope_is_valid',
    11872: 'active_idea_groups',
    11873: 'active_relations',
    11874: 'messagelist_open',
    11875: 'pending_events',
    11876: 'participating_country',
    11877: 'toggle_main_army',
    11878: 'main_army',
    11879: 'hunter_killer',
    11880: 'original_coloniser',
    11881: 'home_area_strait',
    11882: 'tradegoods_supply',
    11883: 'tradegoods_demand',
    11884: 'tradegoods_total_produced',
    11885: 'tradegoods_num_supply_provinces',
    11886: 'tradegoods_num_demand_provinces',
    11887: 'delayed_decay',
    11888: 'draw_particles',
    11889: 'call_for_peace',
    11890: 'on_effect',
    11891: 'off_effect',
    11892: 'inflation_action_cost',
    11893: 'num_of_coalition_members',
    11894: 'relations_over_limit',
    11895: 'remove_pending_event',
    11896: 'is_in_coalition_war',
    11897: 'historical_friend_with',
    11898: 'historical_rival_with',
    11899: 'diplomacy_popup',
    11900: 'foreign_support_for_rebels',
    11901: 'owned_provinces',
    11902: 'controlled_provinces',
    11903: 'core_provinces',
    11904: 'claim_provinces',
    11905: 'update_opinion_cache',
    11906: 'needs_refresh',
    11907: 'needs_rebel_unit_refresh',
    11908: 'refresh_modifier',
    11909: 'top_faction',
    11910: 'total_war_worth',
    11911: 'num_of_controlled_cities',
    11912: 'num_of_core_ports',
    11913: 'num_of_overseas',
    11914: 'num_of_throne_claims',
    11915: 'num_of_heathen_provs',
    11916: 'num_of_heretic_provs',
    11917: 'inland_sea_ratio',
    11918: 'num_of_goods_produced',
    11919: 'num_of_religions',
    11920: 'num_of_leaders',
    11921: 'border_percentage',
    11922: 'neighbours',
    11923: 'home_neighbours',
    11924: 'core_neighbours',
    11925: 'is_neighbour',
    11926: 'is_home_neighbour',
    11927: 'is_core_neighbour',
    11928: 'friends',
    11929: 'vassals',
    11930: 'lesser_union_partners',
    11931: 'allies',
    11932: 'coalition_friends',
    11933: 'guarantees',
    11934: 'warnings',
    11935: 'current_at_war_with',
    11936: 'current_war_allies',
    11937: 'trade_embargoed_by',
    11938: 'transfer_trade_power_to',
    11939: 'transfer_trade_power_from',
    11940: 'relation_costing_power',
    11941: 'recalc_attitude',
    11942: 'previous_winter',
    11943: 'has_winter_modifier',
    11944: 'idea_may_cache',
    11945: 'papal_state',
    11946: 'weighted_cardinal',
    11947: 'has_core_claim',
    11948: 'has_culture_group_claim',
    11949: 'has_religion_group_claim',
    11950: 'has_border_friction_claim',
    11951: 'has_colony_claim',
    11952: 'has_temporary_claim',
    11953: 'fabricating_claim_province',
    11954: 'is_fabricating_claim',
    11955: 'is_infiltrating_administration',
    11956: 'is_sowing_discontent',
    11957: 'is_sabotaging_reputation',
    11958: 'is_supporting_rebels',
    11959: 'is_delete',
    11960: 'is_fighting_war_together',
    11961: 'rebel_threat',
    11962: 'num_of_buildings',
    11963: 'num_of_buildings_under_construction',
    11964: 'produced_goods_value',
    11965: 'latest_pirate_targets',
    11966: 'needs_help',
    11967: 'war_target',
    11968: 'naval_war',
    11969: 'max_land_morale',
    11970: 'max_naval_morale',
    11971: 'update_opinion_cache_command',
    11972: 'gained_casus_bellis_cache',
    11973: 'cb_country_list',
    11974: 'lost_casus_bellis_cache',
    11975: 'third',
    11976: 'forth',
    11977: 'savegame_version',
    11978: 'coalition_date',
    11979: 'rival_time',
    11980: 'has_global_modifier_value',
    11981: 'has_local_modifier_value',
    11982: 'has_unit_type',
    11983: 'production_leader_tag',
    11984: 'oos',
    11985: 'error_code',
    11986: 'important',
    11987: 'war_date',
    11988: 'hre_liberated',
    11989: 'delayed_treasure',
    11990: 'action_token',
    11991: 'num_of_non_cores',
    11992: 'is_tutorial_active',
    11993: 'border_size_in_tax',
    11994: 'border_distance_overseas',
    11995: 'subjects',
    11996: 'update_border_distance',
    11998: 'call_ally_type',
    12000: 'mod_enabled',
    12001: 'dlc_enabled',
    12010: 'age',
    12019: 'ruler_age',
    12027: 'has_colonial_parent',
    12028: 'native_mechanic',
    12029: 'allow_migration',
    12030: 'allow_westernize',
    12031: 'migrate',
    12032: 'last_migration',
    12033: 'native_advancement_cost',
    12034: 'migration_cooldown',
    12035: 'active_native_advancement',
    12036: 'country_tags',
    12037: 'colonial_region',
    12038: 'names',
    12039: 'colonies',
    12040: 'num_of_colonial_countries',
    12041: 'is_colonial_subject',
    12042: 'dynamic_countries',
    12043: 'colonial_parent',
    12044: 'federation_leader',
    12045: 'federation_friends',
    12046: 'request_to_join_federation',
    12047: 'invite_to_federation',
    12048: 'random_world',
    12049: 'used_colonial_names',
    12050: 'tariff',
    12051: 'government_specific',
    12052: 'liberty_desire',
    12053: 'add_liberty_desire',
    12054: 'is_colonial_nation_of',
    12055: 'is_colonial_nation',
    12057: 'create_protectorate',
    12058: 'protectorate',
    12059: 'is_protectorate',
    12060: 'num_of_protectorates',
    12061: 'protectorates',
    12062: 'protectorateaction',
    12063: 'deny_annex',
    12064: 'po_humiliate',
    12065: 'humiliate',
    12066: 'po_become_protectorate',
    12067: 'has_subject',
    12068: 'set_country_name',
    12069: 'map_color',
    12070: 'adjective',
    12071: 'is_former_colonial_nation',
    12072: 'abandon_colony',
    12073: 'num_owned_home_cores',
    12074: 'force_coastal',
    12075: 'local_hostile_attrition',
    12076: 'dirty_colony',
    12077: 'num_of_colonial_subjects',
    12078: 'support_independence_action',
    12079: 'support_independence',
    12080: 'num_of_independence_supporters',
    12081: 'extra_province_names',
    12082: 'trade_winds',
    12083: 'reform_native',
    12085: 'observe_mode',
    12086: 'add_tariff_value',
    12087: 'tariff_value',
    12088: 'native_size_before_migration',
    12089: 'release_colony',
    12090: 'westernisation_needed',
    12091: 'score_rating',
    12092: 'score_rank',
    12093: 'country_color',
    12094: 'add_yearly_manpower',
    12095: 'players_countries',
    12096: 'every_subject_country',
    12097: 'any_subject_country',
    12098: 'all_subject_country',
    12099: 'random_subject_country',
    12100: 'set_random_new_world_seed',
    12101: 'toggle_can_attach_to',
    12102: 'can_attach',
    12103: 'opportunism',
    12104: 'update_supply_range',
    12105: 'nonhistoricaldynastyforhistoricalmonarch',
    12106: 'num_of_diplomatic_relations',
    12107: 'num_of_free_diplomatic_relations',
    12108: 'military_rating_cache',
    12109: 'custom_trigger_tooltip',
    12110: 'has_new_dynasty',
    12111: 'multiply_variable',
    12112: 'divide_variable',
    12113: 'real_month_of_year',
    12114: 'real_day_of_year',
    12116: 'subtract_variable',
    12117: 'ignore_decision',
    12118: 'ignore_decision_command',
    12119: 'stop_improve_relations_command',
    12120: 'inactive',
    12121: 'initialized_rivals',
    12122: 'floating_chat_text',
    12123: 'total_base_tax',
    12124: 'country_or_vassal_holds',
    12125: 'is_justifying_trade_conflict',
    12126: 'justify_trade_conflict',
    12127: 'sabotage_trade',
    12128: 'transfer_trade_cost_factor',
    12129: 'justify_trade_conflict_cost',
    12130: 'improve_relation_modifier',
    12131: 'is_great_power',
    12132: 'dipcost_factor',
    12133: 'administrative_efficiency',
    12134: 'returned_core',
    12135: 'trade_power_others',
    12136: 'is_enforced',
    12137: 'inland',
    12142: 'global_heretic_missionary_strength',
    12144: 'privateer_mission',
    12145: 'merchant_present_inland',
    12146: 'merchant_steering_to_inland',
    12147: 'trade_port',
    12148: 'trade_share',
    12150: 'has_privateers',
    12151: 'share',
    12152: 'boost_income',
    12153: 'enable_unlockable',
    12154: 'blockade_ports',
    12155: 'active_policy',
    12156: 'disable_unlockable',
    12157: 'user_changed_name',
    12158: 'privateer_power',
    12159: 'random_privateering_country',
    12160: 'every_privateering_country',
    12161: 'any_privateering_country',
    12162: 'all_privateering_country',
    12163: 'detach_obsolete',
    12164: 'pay_all_loans',
    12165: 'leader_land_fire',
    12166: 'leader_land_shock',
    12167: 'leader_naval_fire',
    12168: 'leader_naval_shock',
    12169: 'siege_ability',
    12170: 'privateer_efficiency',
    12171: 'global_trade_goods_size',
    12172: 'envoy_travel_time',
    12173: 'ae_impact',
    12174: 'has_active_policy',
    12175: 'has_climate',
    12176: 'has_winter',
    12177: 'unsafe_move_command',
    12178: 'trade_company_region',
    12179: 'add_fervor',
    12180: 'fervor',
    12181: 'toggle_fervor_effect',
    12182: 'monthly_fervor_increase',
    12183: 'fixed_capital',
    12184: 'num_of_trade_companies',
    12185: 'is_owned_by_trade_company',
    12186: 'trade_company_size',
    12187: 'num_of_trade_companies_in_region',
    12188: 'hre_vote',
    12189: 'add_great_project',
    12190: 'add_construction_progress',
    12191: 'has_great_project',
    12192: 'build_canal_construction',
    12194: 'great_project_construction',
    12195: 'construction_progress',
    12196: 'is_canal',
    12197: 'great_projects',
    12198: 'trade_company',
    12199: 'cancel_construction',
    12200: 'old_name',
    12201: 'add_to_trade_company',
    12202: 'remove_from_trade_company',
    12203: 'cancel_last_unit_in_queue',
    12204: 'has_active_fervor',
    12205: 'monthly_decay',
    12206: 'add_rival',
    12207: 'remove_rival',
    12208: 'current_power_projection',
    12209: 'power_projection',
    12210: 'company_cache',
    12211: 'strong_company',
    12212: 'toggle_go_home_at_war',
    12213: 'go_home_at_war',
    12214: 'army_strength',
    12215: 'enforce_fleet_basing_rights',
    12216: 'enforce_military_access',
    12217: 'po_enforce_fleet_basing_rights',
    12218: 'po_enforce_military_access',
    12219: 'is_republic',
    12221: 'auto_invest_in_cardinal',
    12222: 'personal_deity',
    12223: 'change_personal_deity',
    12224: 'has_personal_deity',
    12225: 'province_list',
    12226: 'had_recent_war',
    12227: 'colonial_father',
    12228: 'colonial_flag_color',
    12229: 'supply_limit_modifier',
    12230: 'blockaded_percent',
    12231: 'hre_reform_level',
    12232: 'navy_strength',
    12233: 'canal_definition',
    12234: 'is_random_new_world',
    12235: 'transferred_out',
    12236: 'transferred_in',
    12237: 'transfered_to_index',
    12238: 'transfered_to_value',
    12239: 'transfered_from_index',
    12240: 'transfered_from_value',
    12241: 'visible_in_all_map_modes',
    12242: 'hidden_on_start',
    12243: 'attacker_call_all',
    12244: 'home_trade_node',
    12245: 'num_of_strong_trade_companies',
    12246: 'was_player',
    12247: 'local_ironman',
    12248: 'capped_opinion_value',
    12249: 'original_tax',
    12250: 'kill_monarch',
    12251: 'original_capital',
    12252: 'previous_country_tags',
    12253: 'num_of_free_leaders',
    12254: 'effective_score_impact',
    12255: 'change_statists_vs_orangists',
    12256: 'dutch_mechanics',
    12257: 'is_statists_in_power',
    12258: 'is_orangists_in_power',
    12259: 'statists_vs_orangists',
    12260: 'dictatorship',
    12261: 'add_scaled_republican_tradition',
    12262: 'global_ship_repair',
    12263: 'vassal_forcelimit_bonus',
    12264: 'years_of_nationalism',
    12265: 'accepted_culture_threshold',
    12266: 'culture_conversion_cost',
    12267: 'diplomatic_annexation_cost',
    12268: 'ship_durability',
    12269: 'last_warscore',
    12270: 'ahead_of_time',
    12271: 'foreign_heir',
    12272: 'is_elective',
    12273: 'has_foreign_heir',
    12274: 'heir_nationality',
    12275: 'ruler_is_foreigner',
    12276: 'national_focus',
    12277: 'set_national_focus_command',
    12278: 'support_heir',
    12279: 'support_own_heir',
    12280: 'risk_of_union',
    12281: 'development_cost',
    12282: 'add_heir_support',
    12283: 'set_ruler_flag',
    12284: 'clr_ruler_flag',
    12285: 'has_ruler_flag',
    12286: 'had_ruler_flag',
    12287: 'ruler_flags',
    12288: 'needs_regiments_command',
    12289: 'needs_ships_command',
    12290: 'needs_buildings_command',
    12291: 'war_score_against',
    12292: 'has_harsh_treatment',
    12293: 'replace_rival_command',
    12294: 'replace_rival_countrytag',
    12295: 'add_truce_with',
    12296: 'previous_government_type',
    12297: 'active_trade_company',
    12298: 'kill_monarch_command',
    12299: 'add_monarch_power_command',
    12300: 'add_republican_tradition_command',
    12301: 'transfer_controller_command',
    12302: 'upgrade_fleet_token',
    12303: 'local_unrest',
    12304: 'global_unrest',
    12305: 'unrest',
    12306: 'pure_unrest',
    12307: 'abandon_core_command',
    12308: 'local_autonomy',
    12310: 'allied_objective',
    12311: 'set_subject_military_focus',
    12312: 'subject_country',
    12313: 'subject_focus',
    12314: 'po_dismantle_forts',
    12315: 'po_give_up_claim',
    12316: 'claim_to_give_up',
    12317: 'designate_march',
    12318: 'marches',
    12319: 'num_of_marches',
    12320: 'is_march',
    12321: 'ask_for_march',
    12322: 'has_spawned_supported_rebels',
    12327: 'abandon_idea_group',
    12328: 'sell_ships_action',
    12329: 'autosave_on_events',
    12330: 'unit_naming',
    12331: 'global_autonomy',
    12332: 'terrain_override',
    12333: 'po_enforce_rebel_demands',
    12334: 'enforce_rebel_demands',
    12335: 'has_supportive_war',
    12336: 'switch_tag',
    12337: 'add_unrest',
    12338: 'add_local_autonomy',
    12339: 'random_rebel_province',
    12340: 'every_rebel_province',
    12341: 'needs_regiments',
    12342: 'needs_ships',
    12343: 'needs_buildings',
    12344: 'occupying_rebel_faction',
    12345: 'min_autonomy',
    12346: 'toggle_auto_transfer',
    12348: 'add_reform_center',
    12350: 'transfered_to',
    12351: 'transfered_from',
    12353: 'use_ai_money_command',
    12354: 'client_countries',
    12355: 'used_client_names',
    12356: 'create_guarantee',
    12357: 'convert_ruler_to_general',
    12358: 'convert_heir_to_general',
    12359: 'define_ruler_to_general',
    12360: 'define_heir_to_general',
    12361: 'can_use_trade_post',
    12362: 'years_in_union_under',
    12363: 'years_in_vassalage_under',
    12364: 'full_ally',
    12365: 'has_guaranteed',
    12366: 'guaranteed_by',
    12367: 'increase_autonomy_command',
    12368: 'decrease_autonomy_command',
    12369: 'has_rebel_faction',
    12370: 'kill_cardinal',
    12371: 'total_number_of_cardinals',
    12372: 'has_cardinal',
    12373: 'client_state',
    12374: 'client_states',
    12375: 'num_of_clients',
    12376: 'save_event_target_as',
    12377: 'auto_transfer_mode',
    12378: 'reformation_center',
    12381: 'is_reformation_center',
    12382: 'papal_tag',
    12383: 'election_cost',
    12384: 'seat_of_papacy',
    12385: 'invest_papal_influence_command',
    12386: 'papacy_action_command',
    12387: 'saved_event_target',
    12388: 'max_autonomy',
    12389: 'po_dismantle_revolution',
    12390: 'dismantle_revolution',
    12392: 'will_relocate',
    12393: 'revolution_target_original_name',
    12394: 'march',
    12395: 'previous_controller',
    12396: 'has_first_revolution_started',
    12397: 'mothball_command',
    12398: 'papal_investment',
    12399: 'hre_religion',
    12400: 'hre_heretic_religion',
    12401: 'is_mtth_scaled_to_size',
    12402: 'league',
    12403: 'join_religion_league',
    12404: 'recalculate_score',
    12405: 'toggle_allow_foreign_armies',
    12406: 'allow_foreign_armies',
    12407: 'save_global_event_target_as',
    12408: 'clear_global_event_target',
    12409: 'clear_global_event_targets',
    12410: 'in_league',
    12411: 'hre_leagues_enabled',
    12412: 'enable_hre_leagues',
    12413: 'add_province_to_client_state',
    12414: 'create_client_state',
    12416: 'province_warscore_cost',
    12417: 'transfer_home_bonus',
    12418: 'march_of',
    12419: 'can_create_marches',
    12420: 'is_possible_march',
    12421: 'colonial_liberty_desire',
    12422: 'spread',
    12423: 'unit_templates',
    12424: 'army_templates',
    12425: 'navy_templates',
    12426: 'set_hre_religion',
    12427: 'set_hre_religion_locked',
    12428: 'set_hre_heretic_religion',
    12429: 'hre_leagues_status',
    12430: 'hre_religion_status',
    12431: 'hre_religion_locked',
    12432: 'set_hre_religion_treaty',
    12433: 'hre_religion_treaty',
    12434: 'is_league_enemy',
    12435: 'is_league_friend',
    12436: 'po_change_hre_religion',
    12437: 'change_hre_religion',
    12438: 'change_price',
    12439: 'has_terrain',
    12440: 'current_price',
    12441: 'last_conversion',
    12442: 'calc_true_if',
    12443: 'build_template_command',
    12444: 'allow_client_states',
    12445: 'subject_color',
    12446: 'subject_symbol_index',
    12447: 'num_symbols',
    12448: 'po_war_reparations',
    12449: 'war_reparations',
    12450: 'allowed_center_conversion',
    12451: 'po_humiliate_rival',
    12452: 'humiliate_rival',
    12453: 'winner_alliance',
    12454: 'loser_alliance',
    12455: 'is_client_nation',
    12456: 'is_client_nation_of',
    12457: 'gfx_settings',
    12458: 'camera_look_at',
    12459: 'camera_position',
    12460: 'fov',
    12461: 'near',
    12462: 'far',
    12463: 'world',
    12464: '3d_combat_result',
    12465: 'min_zoom',
    12466: 'max_zoom',
    12467: 'subject_symbol_color',
    12468: 'subject_symbol_color_index',
    12469: 'compress_autosave',
    12470: 'renew_wartaxes',
    12471: 'can_take_wartaxes',
    12472: 'num_template_units_to_merge',
    12473: 'is_in_league_war',
    12474: 'sponsor',
    12475: 'can_form_personal_unions',
    12480: 'is_in_capital_area',
    12481: 'new_monarch',
    12482: 'set_auto_transport_path_command',
    12483: 'set_navies_on_autotransport_mission_command',
    12484: 'join_league',
    12485: 'leave_league',
    12486: 'remove_reform_center',
    12487: 'ai_peace_desire',
    12488: 'in_debt',
    12489: 'cancel_autofleet',
    12492: 'update_macro',
    12493: 'is_league_leader',
    12494: 'supportive_country',
    12495: 'valid_for_subject',
    12496: 'remove_cardinal',
    12497: 'add_cardinal',
    12498: 'perform_unit_action_command',
    12499: 'navies_to_ask_autofleet',
    12500: 'is_small_march',
    12501: 'temp',
    12502: 'unit_list',
    12503: 'last_war_status',
    12504: 'compress_saves',
    12505: 'auto_transfer_army',
    12506: 'auto_transport_path',
    12507: 'client_parent',
    12508: 'participants',
    12509: 'center_of_religion',
    12510: 'target_merge_province',
    12511: 't_in',
    12512: 't_out',
    12513: 'max_pow',
    12514: 'val',
    12515: 't_to',
    12516: 't_from',
    12517: 'add',
    12518: 'p_pow',
    12519: 'auto_transfer_navy',
    12520: 'start_auto_fleet_transport',
    12521: 'needs_update',
    12522: 'delete',
    12523: 'auto_fleet_transport',
    12524: 'graphical_auto_transport_path',
    12525: 'has_switched_nation',
    12526: 'can_start',
    12527: 'can_end',
    12528: 'on_start',
    12529: 'on_monthly',
    12530: 'active_disaster',
    12531: 'has_disaster',
    12532: 'has_any_disaster',
    12533: 'on_end',
    12534: 'unit_template_id',
    12535: 'awaiting_units',
    12536: 'disaster_progress',
    12537: 'end_disaster',
    12538: 'num_ships_privateering',
    12539: 'will_get_center',
    12540: 'average_autonomy',
    12541: 'average_home_autonomy',
    12542: 'relocation_province',
    12543: 'relocation_date',
    12544: 'relocation_start_date',
    12545: 'is_relocating',
    12546: 'original_hre_religion',
    12547: 'original_hre_heretic_religion',
    12548: 'declare_war_in_regency',
    12549: 'doom',
    12550: 'religious_reforms',
    12551: 'add_ai_colonize',
    12552: 'add_ai_conquer',
    12553: 'add_ai_threat',
    12554: 'add_ai_antagonize',
    12555: 'add_ai_befried',
    12556: 'add_ai_protect',
    12557: 'add_ai_rival',
    12558: 'add_ai_protectorate',
    12559: 'update_overseas_cores',
    12560: 'overseas_core',
    12561: 'active_days_this_month',
    12562: 'active_fraction_last_month',
    12563: 'update_custom_country',
    12564: 'remove_custom_country',
    12565: 'changed_capitals',
    12566: 'country_colors',
    12567: 'original_owner',
    12568: 'treasure_fleet_gold',
    12569: 'textures',
    12570: 'flag_colors',
    12571: 'caravan_power',
    12572: 'uses_doom',
    12573: 'can_buy_idea',
    12574: 'release_all_subjects',
    12575: 'sacrifice_ruler_command',
    12576: 'sacrifice_heir_command',
    12577: 'add_doom',
    12578: 'active_religious_reform',
    12579: 'flag_color',
    12580: 'valid_for_nation_designer',
    12581: 'nation_designer_cost',
    12582: 'has_friendly_reformation_center',
    12583: 'has_hostile_reformation_center',
    12585: 'randomlog_hotjoin',
    12586: 'reform_religion_command',
    12587: 'has_reformed_religion',
    12588: 'authority',
    12589: 'release_all_cores',
    12590: 'male_names',
    12591: 'female_names',
    12592: 'add_authority',
    12593: 'uses_authority',
    12594: 'reform_tooltip',
    12595: 'commandooslog',
    12596: 'console_command',
    12597: 'command_string',
    12598: 'is_variable_equal',
    12599: 'finalize_custom_country',
    12600: 'remove_religious_reforms',
    12602: 'disaster_started',
    12603: 'can_stop',
    12604: 'pirate_hunt',
    12605: 'cost_index',
    12606: 'custom_national_ideas',
    12607: 'custom_national_ideas_level',
    12608: 'level_cost_1',
    12609: 'level_cost_2',
    12610: 'max_level',
    12612: 'removed_by_host',
    12613: 'revolutionary_colors',
    12614: 'extra_cost',
    12615: 'revolutionary_flag_texture',
    12616: 'unfinalize_custom_country',
    12617: 'flag_emblem_index_range',
    12618: 'flags_with_emblem_percentage',
    12619: 'savegame_versions',
    12620: 'giver',
    12621: 'taker',
    12622: 'is_selected',
    12623: 'is_demand',
    12625: 'offer_giver',
    12626: 'preferred_coalition_target',
    12627: 'preferred_coalition_score',
    12628: 'preferred_coalition_against_us',
    12629: 'explore_mission',
    12630: 'explore',
    12631: 'override',
    12632: 'explore_target',
    12633: 'has_circumnavigated_world',
    12634: 'is_religion_reformed',
    12635: 'level_cost_3',
    12636: 'level_cost_4',
    12637: 'level_cost_5',
    12638: 'level_cost_6',
    12639: 'level_cost_7',
    12640: 'level_cost_8',
    12641: 'level_cost_9',
    12642: 'level_cost_10',
    12643: 'last_sacrifice',
    12644: 'set_random_province_base_tax',
    12646: 'colonial_name_source',
    12647: 'update_custom_country_heir',
    12648: 'randomize_death_date',
    12649: 'set_custom_country_ruler_or_heir_properties',
    12650: 'set_custom_country_government',
    12651: 'create_custom_country',
    12652: 'provinces_only',
    12653: 'last_spy_discovery',
    12654: 'custom_heir_female',
    12655: 'custom_ruler_female',
    12656: 'custom_heir_name',
    12657: 'custom_ruler_name',
    12658: 'nation_designer_unit_type',
    12661: 'last_looted',
    12662: 'loot_remaining',
    12663: 'remove_electorate',
    12664: 'church',
    12665: 'last_month_treasure_fleet_gold',
    12666: 'custom_country_name',
    12667: 'is_playing_custom_nation',
    12668: 'num_of_ports_blockading',
    12669: 'province_trigger',
    12670: 'can_join_hre_league',
    12671: 'can_leave_hre_league',
    12672: 'condition',
    12673: 'saved_character',
    12674: 'ruler_male',
    12675: 'ruler_female',
    12676: 'allow_only_male',
    12677: 'allow_only_female',
    12678: 'permanent_accepted_culture',
    12679: 'dissolved_parliament',
    12680: 'global_tax_income',
    12681: 'nation_designer_trigger',
    12682: 'add_disaster_modifier',
    12683: 'disaster',
    12684: 'collapse_nation',
    12685: 'random_nation_chance',
    12686: 'random_nation_extra_size',
    12687: 'custom_name',
    12688: 'recalculate_strategy',
    12689: 'rank_1',
    12690: 'rank_2',
    12691: 'rank_3',
    12692: 'ruler_1',
    12693: 'ruler_1_female',
    12694: 'ruler_2',
    12695: 'ruler_2_female',
    12696: 'ruler_3',
    12697: 'ruler_3_female',
    12698: 'government_rank',
    12700: 'set_government_rank',
    12701: 'fixed_rank',
    12702: 'government_rank_command',
    12703: 'trade_goods_size_modifier',
    12704: 'global_trade_goods_size_modifier',
    12707: 'add_building_construction',
    12708: 'add_core_construction',
    12709: 'add_culture_construction',
    12710: 'add_missionary_construction',
    12711: 'change_graphical_culture',
    12712: 'break_marriage',
    12713: 'mercenary_infantry',
    12714: 'mercenary_cavalry',
    12715: 'num_of_custom_nations',
    12716: 'normal_province_values',
    12717: 'fort_maintenance_modifier',
    12718: 'has_parliament',
    12719: 'has_devotion',
    12720: 'add_base_manpower',
    12721: 'add_base_production',
    12722: 'base_production',
    12723: 'improve_count',
    12724: 'local_development_cost',
    12725: 'allowed_num_of_buildings',
    12726: 'make_obsolete',
    12727: 'fort_influencing',
    12728: 'mothball_fort',
    12729: 'highest_possible_fort',
    12730: 'num_of_times_improved',
    12731: 'development',
    12732: 'base_manpower',
    12733: 'lazy_load',
    12734: 'num_of_rebel_controlled_provinces',
    12735: 'num_of_rebel_armies',
    12736: 'devotion',
    12737: 'add_devotion',
    12738: 'is_previous_papal_controller',
    12739: 'seat_in_parliament',
    12740: 'current_size_of_parliament',
    12741: 'set_seat_in_parliament',
    12743: 'add_to_parliament_command',
    12744: 'has_seat_in_parliament',
    12747: 'has_active_debate',
    12748: 'current_debate',
    12749: 'back_current_issue',
    12750: 'active_parliament_issue',
    12751: 'start_debate_command',
    12752: 'bribe',
    12753: 'employed_advisor',
    12754: 'aspect',
    12755: 'change_church_aspect',
    12756: 'karma',
    12757: 'uses_karma',
    12758: 'set_karma',
    12759: 'add_karma',
    12760: 'subject',
    12761: 'placate_rulers',
    12762: 'embargo_rivals',
    12763: 'interaction',
    12764: 'subject_interactions',
    12765: 'place_relative_on_throne',
    12766: 'enforce_religion',
    12767: 'scutage',
    12768: 'subsidize_armies',
    12769: 'fortify_march',
    12770: 'influencing_fort',
    12771: 'last_debate',
    12772: 'development_efficiency',
    12773: 'church_power',
    12774: 'has_church_aspect',
    12775: 'add_church_power',
    12776: 'add_church_aspect',
    12777: 'remove_church_aspect',
    12778: 'church_power_modifier',
    12779: 'garrison_size',
    12780: 'loot_amount',
    12781: 'mothballed_forts',
    12782: 'has_set_government_name',
    12783: 'raw_development',
    12784: 'return_province_command',
    12785: 'westernization_paused',
    12786: 'pause_westernization_command',
    12787: 'free_city',
    12790: 'grant_freecity',
    12791: 'remove_freecity',
    12792: 'base_fort_level',
    12793: 'parliament_issues',
    12794: 'recalculate_issues',
    12795: 'gave_access',
    12796: 'allow_in_gold_provinces',
    12797: 'capped_development',
    12801: 'local_build_cost',
    12802: 'female_advisor_chance',
    12803: 'raze_power_gain',
    12804: 'martin_token_101',
    12805: 'martin_token_102',
    12806: 'martin_token_103',
    12807: 'martin_token_104',
    12808: 'martin_token_105',
    12809: 'martin_token_106',
    12810: 'martin_token_107',
    12811: 'total_development',
    12812: 'is_backing_current_issue',
    12813: 'num_of_aspects',
    12814: 'num_of_war_reparations',
    12815: 'is_in_deficit',
    12816: 'subsidised_percent_amount',
    12817: 'is_federation_leader',
    12818: 'federation_size',
    12819: 'invested_papal_influence',
    12820: 'num_free_building_slots',
    12821: 'add_horde_unity',
    12822: 'set_estate',
    12823: 'remove_estate',
    12824: 'add_estate_influence_modifier',
    12825: 'create_independent_estate',
    12826: 'create_independent_estate_from_religion',
    12827: 'add_estate_loyalty_modifier',
    12828: 'grant_independence',
    12829: 'after',
    12830: 'martin_token_209',
    12831: 'nation_rebel_tag',
    12832: 'enforce_culture',
    12833: 'siphon_income',
    12834: 'support_loyalists',
    12835: 'send_officers',
    12836: 'divert_trade',
    12837: 'seize_territory',
    12838: 'start_colonial_war',
    12839: 'replace_governor',
    12840: 'third_party',
    12841: 'builder',
    12842: 'last_forced_election',
    12843: 'promote_investments',
    12844: 'has_embargo_rivals',
    12845: 'has_scutage',
    12846: 'has_subsidize_armies',
    12847: 'has_support_loyalists',
    12848: 'has_send_officers',
    12849: 'has_divert_trade',
    12850: 'has_promote_investments',
    12851: 'update_map',
    12852: 'customized_flag',
    12853: 'forts',
    12854: 'mothball_all',
    12855: 'mothball',
    12856: 'givers',
    12857: 'takers',
    12858: 'war_givers',
    12859: 'war_takers',
    12860: 'clear_all_but_next',
    12861: 'fort_flip_progress',
    12862: 'fort_flipper',
    12863: 'on_issue_taken',
    12864: 'po_concede_colonial_region',
    12865: 'study_technology',
    12866: 'agitate_for_liberty',
    12867: 'is_studying_technology',
    12868: 'is_agitating_for_liberty',
    12869: 'is_agitated_for_liberty',
    12870: 'concede_colonial_region',
    12871: 'liberty_agitation',
    12872: 'army_template',
    12873: 'navy_template',
    12874: 'grant_province',
    12875: 'grant_core_claim',
    12876: 'add_permanent_claim',
    12877: 'increase_tariffs',
    12878: 'decrease_tariffs',
    12879: 'offer_taker',
    12880: 'uses_church_power',
    12881: 'aspects',
    12882: 'set_shadow_templates',
    12883: 'original_culture',
    12884: 'dismiss_advisor',
    12885: 'former_native_size',
    12886: 'naval_patrol',
    12887: 'add_scaled_local_adm_power',
    12888: 'add_scaled_local_dip_power',
    12889: 'add_scaled_local_mil_power',
    12890: 'kill_units',
    12891: 'set_local_autonomy',
    12894: 'excommunicate',
    12895: 'add_historical_friend',
    12896: 'remove_historical_friend',
    12897: 'add_historical_rival',
    12898: 'remove_historical_rival',
    12899: 'exile_ruler_as',
    12900: 'num_of_units_in_province',
    12901: 'has_ruler_leader_from',
    12902: 'has_heir_leader_from',
    12903: 'heir_adm',
    12904: 'heir_dip',
    12905: 'heir_mil',
    12906: 'has_disaster_progress',
    12910: 'has_influencing_fort',
    12911: 'set_ruler',
    12912: 'exile_heir_as',
    12913: 'set_heir',
    12914: 'define_leader_to_ruler',
    12915: 'create_march',
    12916: 'change_heir_adm',
    12917: 'change_heir_dip',
    12918: 'change_heir_mil',
    12919: 'add_disaster_progress',
    12921: 'parliament_modifier',
    12922: 'nation_designer_cost_multiplier',
    12923: 'num_custom_nation_provinces',
    12924: 'expanded_dip_action_groups',
    12925: 'raze_province',
    12926: 'last_razed',
    12927: 'secondary_religion',
    12928: 'can_have_secondary_religion',
    12930: 'country_as_secondary',
    12931: 'draw_lakes',
    12932: 'triangle_strip',
    12933: 'sea_province',
    12934: 'num_land_provinces',
    12935: 'num_sea_provinces',
    12936: 'only_used_for_random',
    12937: 'random_new_world_file',
    12938: 'lake_province',
    12939: 'cached_relation_costing_power',
    12940: 'truce',
    12941: 'attitude_locked',
    12942: 'has_succession_claim',
    12943: 'is_embargoing',
    12944: 'is_overseas_subject',
    12945: 'average_unrest',
    12946: 'estate_territory',
    12947: 'has_estate_influence_modifier',
    12948: 'has_estate_loyalty_modifier',
    12949: 'is_island',
    12950: 'started_in',
    12951: 'henrik_token_6',
    12952: 'henrik_token_7',
    12953: 'henrik_token_8',
    12954: 'henrik_token_9',
    12955: 'henrik_token_10',
    12956: 'right_to_bear_arms',
    12957: 'invasion_nation',
    12958: 'percentage_backing_issue',
    12959: 'discount',
    12960: 'last_offensive_call',
    12961: 'remove_loot',
    12964: 'convert_female_ruler_to_general',
    12965: 'convert_female_heir_to_general',
    12966: 'dissolve_parliament',
    12967: 'reinstate_parliament',
    12968: 'while',
    12969: 'export_to_variable',
    12970: 'add_territorial_core',
    12971: 'remove_territorial_core',
    12972: 'niklas_token_54',
    12973: 'niklas_token_55',
    12974: 'num_of_powerful_estates',
    12975: 'num_of_trusted_allies',
    12976: 'nation_designer_points',
    12977: 'highest_value_trade_node',
    12979: 'has_active_parliament',
    12980: 'stop_naval_mission',
    12981: 'ironman_difficulty_check',
    12982: 'monastic',
    12983: 'province_trade_power',
    12984: 'displayed_country_name',
    12986: 'may_study_technology',
    12987: 'may_agitate_for_liberty',
    12988: 'superregion',
    12989: 'colonialwar',
    12990: 'provincegroup',
    12991: 'automatic_maintenance',
    12992: 'autojoin',
    12993: 'last_razed_by',
    12994: 'original_religion',
    12996: 'original_total',
    12997: 'movement_progress_last_updated',
    12998: 'martin_token_210',
    12999: 'martin_token_108',
    13000: 'martin_token_109',
    13001: 'favors',
    13002: 'destroy_money_command',
    13003: 'military_strength_with_allies',
    13004: 'player_attitude',
    13005: 'set_player_attitude_command',
    13006: 'interesting_provinces',
    13007: 'vital_provinces',
    13008: 'player_province_interest_command',
    13009: 'add_trust_command',
    13010: 'prepare_for_war_command',
    13011: 'promised_land',
    13012: 'wants_provinces',
    13013: 'trust_value',
    13014: 'estate',
    13015: 'province_modifier_happy',
    13016: 'province_modifier_angry',
    13017: 'country_modifier_happy',
    13018: 'country_modifier_angry',
    13019: 'loyalty',
    13021: 'add_to_estate_command',
    13022: 'estate_interaction_command',
    13023: 'restrict_to_north_edge',
    13024: 'restrict_to_south_edge',
    13025: 'last_estate_grant',
    13026: 'province_influence',
    13027: 'non_overseas_development',
    13028: 'influence_modifier',
    13029: 'base_influence',
    13030: 'min_territory',
    13031: 'min_provinces_to_want_territory',
    13032: 'horde_unity',
    13033: 'has_secondary_religion',
    13034: 'secondary',
    13035: 'change_to_secondary_religion',
    13036: 'trigger_switch',
    13037: 'set_native_policy',
    13038: 'native_policy',
    13039: 'last_native_uprising',
    13040: 'native_uprising_chance',
    13041: 'native_assimilation',
    13042: 'can_migrate',
    13043: 'po_force_migration',
    13044: 'last_conversion_secondary',
    13045: 'target_unit_templates',
    13046: 'victory_card',
    13047: 'card_score',
    13048: 'wasteland_province',
    13049: 'strait',
    13050: 'through',
    13051: 'do_not_rotate',
    13052: 'unique',
    13053: 'province_names',
    13054: 'regions',
    13055: 'dynamic',
    13056: 'region_centers',
    13057: 'always_remove_on_religious_conquest',
    13058: 'wasteland',
    13059: 'prepare_war',
    13060: 'sacrifice_ruler',
    13061: 'sacrifice_heir',
    13062: 'customize_subject',
    13063: 'threaten_war',
    13064: 'colonial_war',
    13065: 'last_threatened',
    13066: 'last_sent_alliance_offer',
    13067: 'highest_possible_fort_building',
    13068: 'mercenary_artillery',
    13069: 'random_countries',
    13070: 'last_study_tech',
    13071: 'new_world',
    13072: 'max_in_other_direction',
    13073: 'was_fulfilled',
    13074: 'map_modes',
    13075: 'autonomy_does_not_affect',
    13076: 'num_of_regulars',
    13077: 'is_ceiling',
    13078: 'primary_mapmodes',
    13079: 'not_observer',
    13080: 'division_of',
    13081: 'division_at',
    13082: 'expecting_siege',
    13083: 'combat_morale',
    13084: 'trade_league',
    13085: 'invite_to_trade_league',
    13086: 'leave_trade_league',
    13087: 'can_form_trade_league',
    13088: 'request_to_join_trade_league',
    13089: 'trade_leagues',
    13090: 'ignore_end_date',
    13091: 'sharemap',
    13092: 'target_unit_id',
    13093: 'on_trigger',
    13094: 'editor_postfix',
    13095: 'editor',
    13096: 'achievement_ok',
    13097: 'multi_player',
    13098: 'temperate',
    13099: 'total_loyalty',
    13100: 'legitimacy_or_horde_unity',
    13101: 'recovery_motivation',
    13102: 'add_estate_loyalty',
    13103: 'estate_influence',
    13104: 'estate_loyalty',
    13105: 'has_estate',
    13106: 'noestate',
    13107: 'coast',
    13108: 'mountains',
    13109: 'hills',
    13110: 'plains',
    13111: 'desert',
    13112: 'forest',
    13113: 'jungle',
    13114: 'island',
    13115: 'glacial',
    13116: 'territory_power_modifier',
    13117: 'marsh',
    13118: 'river',
    13119: 'loyalty_modifier',
    13120: 'assigned_estates',
    13121: 'territory',
    13122: 'wanted_territory_modifier',
    13123: 'island2',
    13124: 'do_not_rotate_or_mirror',
    13125: 'add_moisture',
    13126: 'min_countries',
    13127: 'max_countries',
    13128: 'min_country_size',
    13129: 'max_country_size',
    13130: 'min_provinces',
    13132: 'min_native_size',
    13133: 'max_native_size',
    13134: 'min_native_hostility',
    13135: 'max_native_hostility',
    13136: 'min_native_ferocity',
    13137: 'max_native_ferocity',
    13138: 'customized_name',
    13139: 'force_apart',
    13140: 'force_together',
    13142: 'rnw_name',
    13143: 'years_between_use',
    13144: 'keep_on_conquest',
    13145: 'interaction_use',
    13146: 'may_not_declare_war',
    13147: 'province_modifier_neutral',
    13148: 'country_modifier_neutral',
    13149: 'gpg_achievement_id',
    13150: 'owner_is_colonial_nation',
    13151: 'prepare_war_date',
    13152: 'block_offensive_call',
    13153: 'block_offensive_call_command',
    13154: 'independence_government',
    13155: 'independence_tech_group',
    13156: 'independence_trigger',
    13157: 'custom_nation_points',
    13158: 'ai_grant_province',
    13159: 'ai_territory_modifier',
    13160: 'fantasy',
    13161: 'country_religion',
    13162: 'buffer',
    13163: 'buffer2',
    13164: 'revoke_trigger',
    13165: 'active_influence',
    13166: 'active_loyalty',
    13167: 'tile_index',
    13168: 'force_all_provinces_owned',
    13169: 'minor_tags',
    13170: 'restrict_to_equator',
    13171: 'last_betrayed_ally',
    13173: 'break_alliance',
    13174: 'may_recruit_female_generals',
    13175: 'rulers_can_be_generals',
    13176: 'spy_network',
    13177: 'is_building_spy_network',
    13178: 'was_colony',
    13179: 'slander_merchants',
    13180: 'corrupt_officials',
    13181: 'has_matching_religion',
    13182: 'fort_flipper_prov',
    13183: 'campaign_id',
    13184: 'anti_nation_ruining_end_date',
    13185: 'custom_nations_enabled',
    13186: 'campaign_length',
    13187: 'areas',
    13188: 'discover_if',
    13189: 'regions_discovered',
    13190: 'rnw_generated',
    13191: 'autopause_in_countryview',
    13192: 'told_user_autopause',
    13193: 'has_custom_ideas',
    13194: 'completed_achievements',
    13195: 'province_group',
    13196: 'is_state',
    13197: 'is_territory',
    13198: 'num_of_states',
    13199: 'num_of_territories',
    13200: 'num_of_provinces_in_states',
    13201: 'num_of_provinces_in_territories',
    13202: 'province_size',
    13203: 'niklas_token_9',
    13206: 'border_pct',
    13207: 'border_sit',
    13208: 'range_cache',
    13209: 'is_home_nb',
    13210: 'is_core_nb',
    13211: 'is_nb',
    13212: 'friend_bools',
    13213: 'leader_id',
    13214: 'monarch_id',
    13215: 'male',
    13216: 'discovery',
    13217: 'fully_discovered',
    13218: 'discovery_date',
    13219: 'has_discovered_region',
    13220: 'has_discovered_capital_region_of',
    13221: 'set_break_alliance_command',
    13223: 'has_any_country_on_continent_discovered_region',
    13224: 'no_edit_save',
    13225: 'co_host',
    13226: 'toggle_co_host',
    13227: 'sailors',
    13228: 'max_sailors',
    13229: 'add_sailors',
    13230: 'global_sailors_modifier',
    13231: 'local_sailors_modifier',
    13232: 'global_sailors',
    13233: 'local_sailors',
    13234: 'sailors_recovery_speed',
    13235: 'add_yearly_sailors',
    13236: 'press_sailors',
    13237: 'perform_slave_raid',
    13238: 'may_perform_slave_raid',
    13239: 'discovery_dates2',
    13240: 'discovery_religion_dates2',
    13241: 'condottieri_action',
    13242: 'condottieri_command',
    13243: 'condottieri_unit_command',
    13244: 'hired_by_country',
    13245: 'hired_for_monthly_cost',
    13246: 'condottieri',
    13247: 'sabotage_recruitment',
    13248: 'condottieri_client',
    13249: 'possible_condottieri',
    13250: 'pending_condottieri_client',
    13251: 'was_previous',
    13252: 'unconditional_surrender',
    13253: 'can_justify_trade_conflict',
    13254: 'is_trade_league_leader',
    13255: 'attacker_disabled_po',
    13256: 'stealmap',
    13257: 'retreat_port',
    13258: 'has_unconditional_surrender',
    13259: 'chosen_port',
    13260: 'days_since_start',
    13261: 'diplomatic_biases',
    13262: 'spy_propensity',
    13263: 'may_steal_maps',
    13264: 'extended_allies',
    13265: 'fake_owner',
    13266: 'hunt_time',
    13267: 'average_effective_unrest',
    13268: 'subunit_limit',
    13269: 'defended_home_strait',
    13270: 'participation',
    13271: 'ai_condottieri_malus_until',
    13272: 'down_progress',
    13273: 'was_safe_retreat_port',
    13274: 'rnw_check_seed',
    13275: 'braindead',
    13276: 'fair_fights',
    13277: 'gift_chance',
    13278: 'different_religion_acceptance',
    13279: 'different_religion_group_acceptance',
    13280: 'power_balance_threat',
    13281: 'supportive_war_country',
    13282: 'supported_rebel_faction',
    13283: 'naval_region_mission',
    13284: 'no_mission',
    13285: 'protect_mission',
    13286: 'privateer_mission_2',
    13287: 'hunt_pirates_mission',
    13288: 'patrol_mission',
    13289: 'evade_mission',
    13290: 'hunt_mission',
    13291: 'blockade_mission',
    13292: 'intercept_mission',
    13293: 'may_slander_merchants',
    13294: 'may_sabotage_recruitment',
    13295: 'may_corrupt_officials',
    13296: 'sailors_percentage',
    13297: 'corruption',
    13298: 'yearly_corruption',
    13299: 'add_corruption',
    13300: 'all_power_cost',
    13301: 'our_spy_network',
    13302: 'root_out_corruption_command',
    13303: 'root_out_corruption',
    13304: 'yearly_corruption_increase',
    13305: 'counterespionage',
    13306: 'is_counterspying',
    13307: 'repair_mission',
    13308: 'ai_attitude',
    13309: 'is_permanent_claim',
    13310: 'is_territorial_core',
    13311: 'is_state_core',
    13312: 'joel_token_4',
    13313: 'joel_token_5',
    13314: 'joel_token_6',
    13315: 'joel_token_7',
    13316: 'joel_token_8',
    13317: 'joel_token_9',
    13318: 'heirs_can_be_generals',
    13319: 'relative_power_class',
    13320: 'transfer_trade_if_merchant_republic',
    13321: 'client_march',
    13322: 'client_vassal',
    13323: 'can_ally',
    13324: 'max_government_rank',
    13325: 'can_be_integrated',
    13326: 'is_voluntary',
    13327: 'colonial_core',
    13328: 'min_local_autonomy',
    13329: 'max_states',
    13330: 'circumnavigate_mission',
    13331: 'explore_mission_2',
    13332: 'explore_army_mission',
    13333: 'mission_settings',
    13334: 'repair_threshold',
    13335: 'aggressiveness',
    13336: 'set_mission_settings_command',
    13338: 'local_naval_engagement_modifier',
    13339: 'global_naval_engagement_modifier',
    13340: 'supportive_country_date',
    13341: 'territorial_core',
    13342: 'make_state_command',
    13343: 'historical_neutral',
    13344: 'hired_condottieri_from',
    13345: 'pending_condottieri',
    13346: 'pending_condottieri_date',
    13347: 'changed_country_name_from',
    13348: 'changed_country_mapcolor_from',
    13349: 'changed_country_adjective_from',
    13350: 'total_military_power',
    13351: 'average_military_power',
    13352: 'random_culture_groups',
    13353: 'state_maintenance_modifier',
    13354: 'abandon_state_command',
    13355: 'promote_mercantilism',
    13356: 'is_in_trade_league',
    13357: 'is_in_trade_league_with',
    13358: 'captured_ship',
    13359: 'global_ship_trade_power',
    13360: 'add_spy_network_in',
    13361: 'add_spy_network_from',
    13362: 'has_spy_network_in',
    13363: 'has_spy_network_from',
    13364: 'trade_league_embargoed_by',
    13365: 'gold_income',
    13366: 'done',
    13367: 'on_my_way',
    13368: 'root_out_corruption_slider',
    13369: 'current_cycle_begin',
    13370: 'great_powers',
    13371: 'leaving',
    13372: 'great_power_score',
    13373: 'great_power_rank',
    13374: 'intervene_in_war',
    13375: 'queen',
    13376: 'kill_queen',
    13377: 'queens',
    13378: 'queen_regent',
    13379: 'do_not_integrate',
    13380: 'realm_development',
    13381: 'reduced_liberty_desire',
    13382: 'may_fabricate_claims',
    13383: 'institutions',
    13384: 'can_embrace',
    13385: 'start_chance',
    13386: 'embracement_speed',
    13387: 'any_friendly_coast_border_province',
    13388: 'has_institution',
    13389: 'is_institution_enabled',
    13390: 'add_institution_embracement',
    13391: 'penalty',
    13392: 'embrace_institution_command',
    13393: 'num_accepted_cultures',
    13394: 'abdicate_command',
    13395: 'add_ruler_personality',
    13396: 'remove_ruler_personality',
    13397: 'add_queen_personality',
    13398: 'remove_queen_personality',
    13399: 'add_heir_personality',
    13400: 'remove_heir_personality',
    13401: 'ruler_has_personality',
    13402: 'queen_has_personality',
    13403: 'heir_has_personality',
    13404: 'clear_scripted_personalities',
    13405: 'royal_marriage_acceptance',
    13406: 'enemy_strength_multiplier',
    13407: 'war_chance_multiplier',
    13408: 'easy_war_chance_multiplier',
    13409: 'different_religion_war_multiplier',
    13410: 'building_budget_multiplier',
    13411: 'random_insults',
    13412: 'random_troop_moves',
    13413: 'wants_gold',
    13414: 'razing',
    13415: 'lower_autonomy',
    13416: 'war_priority',
    13417: 'takeondebt',
    13418: 'spender',
    13419: 'debase_currency',
    13420: 'multiples',
    13421: 'debase_recharge_need',
    13422: 'influence_nation',
    13423: 'influenced_by',
    13424: 'heathen',
    13425: 'true_faith',
    13426: 'institution_origin',
    13427: 'uses_hax',
    13428: 'wants_embrace_institution',
    13429: 'holy_sites',
    13430: 'blessings',
    13431: 'is_blessing',
    13432: 'adm_spent',
    13433: 'dip_spent',
    13434: 'mil_spent',
    13435: 'blessing',
    13436: 'num_of_leaders_with_traits',
    13437: 'forced_break_alliance_date',
    13438: 'random_owned_area',
    13439: 'institutions_penalties',
    13440: 'embracement_cost',
    13441: 'local_institution_spread',
    13442: 'global_institution_spread',
    13443: 'has_merchant',
    13444: 'highlight',
    13445: 'is_primitive',
    13447: 'cavalry_flanking',
    13448: 'shock_damage_received',
    13449: 'movement_speed',
    13450: 'ship_trade_power',
    13451: 'capture_ship_chance',
    13452: 'sunk_ship_morale_hit_recieved',
    13453: 'naval_tradition_from_battle',
    13454: 'fire_damage',
    13455: 'army_tradition_from_battle',
    13456: 'personality_modifier_10',
    13457: 'personality_modifier_11',
    13458: 'personality_modifier_12',
    13459: 'personality_modifier_13',
    13460: 'personality_modifier_14',
    13461: 'is_admiral',
    13462: 'trait',
    13463: 'fetishist_cult',
    13464: 'has_adopted_cult',
    13465: 'has_unlocked_cult',
    13466: 'change_cult',
    13467: 'unlock_cult',
    13468: 'change_blessing',
    13469: 'minimap_units',
    13470: 'is_trading_city',
    13471: 'persistent_attacker',
    13472: 'persistent_defender',
    13473: 'underestimate_ae',
    13474: 'wants_land',
    13475: 'wants_condottieri',
    13476: 'totalexpensetable',
    13477: 'frenzy',
    13478: 'has_harem',
    13479: 'original_dynasty',
    13480: 'max_random_adm',
    13481: 'max_random_dip',
    13482: 'max_random_mil',
    13483: 'institution_difference',
    13484: 'leader_dynasty',
    13485: 'maintain_dynasty',
    13486: 'create_trading_city',
    13487: 'abandon_union',
    13488: 'num_of_active_blessings',
    13489: 'num_of_unlocked_cults',
    13490: 'num_of_admirals_with_traits',
    13491: 'num_of_generals_with_traits',
    13492: 'is_institution_origin',
    13493: 'triggered_faction_name',
    13494: 'ruler_allow',
    13495: 'heir_allow',
    13496: 'consort_allow',
    13497: 'has_consort_regency',
    13498: 'has_consort',
    13499: 'has_female_consort',
    13500: 'has_foreign_consort',
    13501: 'heir_has_consort_dynasty',
    13502: 'heir_has_ruler_dynasty',
    13503: 'consort_age',
    13504: 'consort_dynasty',
    13505: 'consort_has_dynasty_of_ruler',
    13506: 'consort_adm',
    13507: 'consort_dip',
    13508: 'consort_mil',
    13509: 'is_origin_of_consort',
    13510: 'heir_dynasty',
    13511: 'kill_consort',
    13512: 'remove_consort',
    13513: 'remove_heir',
    13514: 'change_consort_adm',
    13515: 'change_consort_dip',
    13516: 'change_consort_mil',
    13517: 'define_consort',
    13518: 'country_of_origin',
    13519: 'consort',
    13520: 'consort_has_personality',
    13521: 'average_autonomy_above_min',
    13522: 'tax_income_percentage',
    13523: 'production_income_percentage',
    13524: 'set_heir_flag',
    13525: 'has_heir_flag',
    13526: 'clr_heir_flag',
    13527: 'set_consort_flag',
    13528: 'has_consort_flag',
    13529: 'clr_consort_flag',
    13530: 'had_heir_flag',
    13531: 'had_consort_flag',
    13532: 'ruler_consort_marriage_length',
    13533: 'change_consort_regent_to_ruler',
    13534: 'no_consort_with_heir',
    13535: 'has_given_consort_to',
    13536: 'required_personality',
    13537: 'consort_male',
    13538: 'consort_female',
    13539: 'heir_male',
    13540: 'heir_female',
    13541: 'gather_point',
    13542: 'ai_condottieri_dont_send_until',
    13543: 'casus_bellis_refresh',
    13544: 'border_provinces',
    13545: 'neighbors_tech_discount',
    13546: 'ck2_converter_generated',
    13547: 'do_not_core',
    13548: 'take_decisions',
    13549: 'embrace_institutions',
    13550: 'develop_provinces',
    13551: 'disband_units',
    13552: 'change_fleet_missions',
    13553: 'send_missionaries',
    13554: 'convert_cultures',
    13555: 'promote_cultures',
    13556: 'update_custom_country_consort',
    13557: 'symbol_index',
    13558: 'custom_colors',
    13559: 'has_saved_event_target',
    13560: 'has_game_started',
    13561: 'is_male',
    13562: 'can_heir_be_child_of_consort',
    13563: 'custom_ai_explanation',
    13564: 'wants_sell_ships',
    13565: 'wants_sell_provinces',
    13566: 'wants_debase',
    13567: 'wants_loans',
    13568: 'wants_avoid_debase',
    13569: 'wants_avoid_loans',
    13570: 'wants_explorers',
    13571: 'wants_disclose_attack',
    13572: 'wants_avoid_ugly_borders',
    13573: 'wants_betray_allies',
    13574: 'wants_threaten_war',
    13575: 'wants_excommunicate',
    13576: 'wants_heretic_land',
    13577: 'wants_heathen_land',
    13578: 'wants_colonies',
    13579: 'other_ai_help_us_multiplier',
    13580: 'other_ai_war_chance_multiplier',
    13581: 'trade_league_acceptance',
    13582: 'alliance_acceptance',
    13583: 'heretic_ally_acceptance',
    13584: 'heathen_ally_acceptance',
    13585: 'other_ai_peace_term_bonus',
    13586: 'peace_desire',
    13587: 'send_warning_desire',
    13588: 'announced_war',
    13589: 'victim',
    13590: 'disinherit_command',
    13591: 'strengthen_government',
    13592: 'wants_to_be_great_power',
    13593: 'remove_unsafe_move',
    13594: 'last_sold_province',
    13595: 'visible_to_ai',
    13596: 'focal_point',
    13597: 'siege_balance',
    13598: 'assigned_region',
    13599: 'king_data',
    13600: 'has_overlords_ruler',
    13601: 'can_fight_independence_war',
    13602: 'can_fight',
    13603: 'copy_from',
    13604: 'can_rival',
    13605: 'add_potential',
    13606: 'add_allow',
    13607: 'created_by_overlord',
    13608: 'uses_tariffs',
    13609: 'base_liberty_desire',
    13610: 'subject_type',
    13611: 'leaked_war_plans',
    13612: 'their_spy_network',
    13613: 'militarised_society',
    13614: 'add_militarised_society',
    13615: 'monthly_militarized_society',
    13616: 'colonial_claim_by_anyone_of_religion',
    13617: 'historical_start_date',
    13618: 'historical_start_province',
    13619: 'start_cost_modifier',
    13620: 'is_religion_grant_colonial_claim',
    13621: 'local_core_creation',
    13622: 'uses_church_aspects',
    13623: 'uses_fervor',
    13624: 'uses_patriarch_authority',
    13625: 'uses_papacy',
    13626: 'uses_blessings',
    13627: 'uses_syncretic_faiths',
    13628: 'uses_cults',
    13629: 'uses_personal_deities',
    13630: 'immortal',
    13631: 'show_ambient_object',
    13632: 'hide_ambient_object',
    13633: 'po_end_rivalry',
    13634: 'draw_terrain_in_uncolonized',
    13635: 'force_potential',
    13636: 'local_state_maintenance_modifier',
    13637: 'build_time',
    13638: 'local_build_time',
    13639: 'timed_modifier',
    13640: 'reinforce_cost_modifier',
    13641: 'is_in_war',
    13642: 'defender_leader',
    13643: 'attacker_leader',
    13644: 'war_goal_province',
    13645: 'comparison',
    13646: 'selector',
    13647: 'sample_value',
    13648: 'sample_count',
    13649: 'campaign_stats',
    13650: 'enabled',
    13651: 'disabled',
    13652: 'temporary_liberty_desire',
    13653: 'draw_state_borders',
    13654: 'idea_claim_trade_regions',
    13655: 'shock_damage',
    13656: 'fire_damage_received',
    13657: 'prosperity',
    13658: 'add_prosperity',
    13659: 'is_prosperous',
    13660: 'devastation',
    13661: 'add_devastation',
    13662: 'active_edict',
    13663: 'enact_edict',
    13664: 'any_province_in_state',
    13665: 'all_province_in_state',
    13666: 'every_province_in_state',
    13667: 'random_province_in_state',
    13668: 'current_age',
    13669: 'num_of_age_objectives',
    13670: 'num_of_continents',
    13671: 'objectives',
    13672: 'abilities',
    13673: 'active_age_ability',
    13674: 'has_age_ability',
    13675: 'age_ability_command',
    13676: 'monthly_splendor',
    13677: 'splendor',
    13678: 'add_splendor',
    13679: 'can_transfer_vassal_wargoal',
    13680: 'can_chain_claim',
    13681: 'free_maintenance_on_expl_conq',
    13682: 'can_colony_boost_development',
    13683: 'attack_bonus_in_capital_terrain',
    13684: 'claim_duration',
    13685: 'religious_conversion_resistance',
    13686: 'placed_merchant_power',
    13687: 'ship_power_propagation',
    13688: 'institution_spread_from_true_faith',
    13689: 'prestige_per_development_from_conversion',
    13690: 'golden_era_date',
    13691: 'enact_golden_age',
    13692: 'absolutism',
    13693: 'add_absolutism',
    13694: 'yearly_absolutism',
    13695: 'max_absolutism',
    13696: 'core_decay_on_your_own',
    13697: 'autonomy_change_time',
    13698: 'rival_change_cost',
    13699: 'rival_border_fort_maintenance',
    13700: 'harsh_treatment_cost',
    13701: 'local_years_of_nationalism',
    13702: 'harsh_treatment',
    13703: 'joins_colonial_wars',
    13704: 'religious_conflicts',
    13705: 'is_ironman',
    13706: 'can_bypass_forts',
    13707: 'ignore_coring_distance',
    13708: 'force_march_free',
    13709: 'reduced_liberty_desire_on_same_continent',
    13710: 'backrow_artillery_damage',
    13712: 'enforce_religion_cost',
    13713: 'has_unified_culture_group',
    13714: 'primary_mapmode_names',
    13715: 'independent_nations',
    13716: 'overlord_can_attack',
    13717: 'overlord_can_be_subject',
    13718: 'can_marry',
    13719: 'counts_for_borders',
    13720: 'can_be_annexed',
    13721: 'diplomacy_overlord_sprite',
    13722: 'diplomacy_subject_sprite',
    13723: 'num_of_subjects',
    13724: 'takes_diplo_slot',
    13725: 'modifier_subject',
    13726: 'modifier_overlord',
    13727: 'liberty_desire_negative_prestige',
    13728: 'liberty_desire_development_ratio',
    13729: 'liberty_desire_same_dynasty',
    13730: 'has_power_projection',
    13731: 'overlord_opinion_modifier',
    13732: 'subject_opinion_modifier',
    13733: 'expiration_message_overlord',
    13734: 'expiration_message_subject',
    13735: 'military_focus',
    13736: 'joins_overlords_wars',
    13737: 'forcelimit_bonus',
    13738: 'cities_required_for_bonuses',
    13739: 'pays_overlord',
    13740: 'can_release_and_play',
    13741: 'dynamically_created_during_history',
    13742: 'eats_overlords_colonies',
    13743: 'diplomacy_view_class',
    13744: 'same_overlord',
    13745: 'other_overlord',
    13746: 'neighboring_primitives',
    13747: 'can_release_in_peace',
    13748: 'celestial_emperor',
    13749: 'war_subjects',
    13750: 'assume_leadership_in_war',
    13751: 'celestial_empire',
    13752: 'num_of_owned_and_controlled_institutions',
    13753: 'has_commanding_three_star',
    13754: 'imperial_mandate',
    13755: 'is_emperor_of_china',
    13756: 'tributary_state',
    13757: 'tributary_state_action',
    13758: 'can_send_tribute',
    13759: 'tribute_type',
    13760: 'set_tribute_type',
    13761: 'select_tribute',
    13762: 'dependency',
    13763: 'uses_military_focus',
    13764: 'ask_for_tributary_state_action',
    13765: 'po_become_tributary_state',
    13766: 'send_tribute',
    13767: 'rickard_token10',
    13768: 'current_institution',
    13769: 'has_state_edict',
    13770: 'local_autonomy_above_min',
    13771: 'overlord_protects_external',
    13772: 'bestow_gifts',
    13773: 'send_additional_troops',
    13774: 'demand_artifacts',
    13775: 'demand_additional_tribute',
    13776: 'overlord_enforce_peace_attacking',
    13777: 'can_use_claims',
    13778: 'po_take_mandate',
    13779: 'has_meritocracy',
    13780: 'meritocracy',
    13781: 'skill_scaled_modifier',
    13782: 'isolationism',
    13783: 'add_meritocracy',
    13784: 'set_meritocracy',
    13785: 'decree',
    13786: 'decree_name',
    13787: 'decree_date',
    13788: 'num_of_subject_count',
    13789: 'liberty_desire_from_subject_development',
    13790: 'empire_of_china_reform_level',
    13791: 'all_state_province',
    13792: 'dismantle_empire_of_china',
    13793: 'set_emperor_of_china',
    13794: 'add_mandate',
    13795: 'set_mandate',
    13796: 'monarch_admin_power',
    13797: 'monarch_diplomatic_power',
    13798: 'monarch_military_power',
    13799: 'create_subject',
    13800: 'can_create_subjects_of_type',
    13801: 'is_subject_of_type',
    13802: 'number',
    13803: 'include_monarch',
    13804: 'include_heir',
    13805: 'has_trait',
    13806: 'has_leaders',
    13807: 'same_continent',
    13808: 'po_transfer_vassals',
    13809: 'confirm_tribute_action',
    13810: 'tribute',
    13811: 'enact_decree',
    13812: 'uses_isolationism',
    13813: 'isolation_value',
    13814: 'variable_name',
    13815: 'variable_initial',
    13816: 'immediate_effect',
    13817: 'force_seppuku',
    13818: 'return_land',
    13819: 'contribute_to_capital',
    13820: 'conscript_general',
    13821: 'force_isolation',
    13822: 'afraid_of_seppuku',
    13823: 'sankin_kotai',
    13824: 'expel_ronin',
    13825: 'sword_hunt',
    13826: 'multi_subject',
    13827: 'cooldowns',
    13828: 'gives_daimyo_bonuses',
    13829: 'weight_multiplier',
    13830: 'localisation_key',
    13831: 'trust_on_start',
    13832: 'has_declared_war',
    13833: 'is_in_important_war',
    13834: 'uses_harmony',
    13835: 'harmony',
    13836: 'harmonizing_with_religion',
    13837: 'harmonization_progress',
    13838: 'yearly_harmony',
    13839: 'harmonized_religions',
    13840: 'harmonize_with_religion',
    13841: 'add_isolationism',
    13842: 'set_isolationism',
    13843: 'add_incident_variable_value',
    13844: 'set_incident_variable_value',
    13845: 'incident_variable_value',
    13846: 'is_incident_potential',
    13847: 'is_incident_active',
    13848: 'is_incident_happened',
    13849: 'is_incident_possible',
    13850: 'incident',
    13851: 'potential_incidents',
    13852: 'active_incidents',
    13853: 'past_incidents',
    13854: 'age_score',
    13855: 'allowed_banner_size',
    13856: 'current_banner',
    13857: 'amount_of_banners',
    13858: 'local_amount_of_banners',
    13859: 'has_banners',
    13860: 'raise_banner_command',
    13861: 'harmonized_modifier',
    13862: 'harmonized_religion_groups',
    13863: 'artillery_bonus_vs_fort',
    13864: 'add_harmony',
    13865: 'add_harmonization_progress',
    13866: 'harmonization_speed',
    13867: 'add_harmonized_religion',
    13868: 'next_age_progress',
    13869: 'is_harmonizing_with',
    13870: 'rickard_token_1',
    13871: 'rickard_token_2',
    13872: 'rickard_token_3',
    13873: 'rickard_token_4',
    13874: 'rickard_token_5',
    13875: 'rickard_token_6',
    13876: 'rickard_token_7',
    13877: 'rickard_token_8',
    13878: 'rickard_token_9',
    13879: 'rickard_token_10',
    13880: 'else',
    13881: 'artillery_barrage',
    13882: 'has_harmonized_with',
    13883: 'automate_diplomat_command',
    13884: 'can_have_subjects_of_other_types',
    13885: 'local_has_banners',
    13886: 'automated_envoys',
    13887: 'automated_envoy',
    13888: 'owns_or_subject_of',
    13889: 'owns_or_non_sovereign_subject_of',
    13890: 'country_or_subject_holds',
    13891: 'country_or_non_sovereign_subject_holds',
    13892: 'variable_arithmetic_trigger',
    13893: 'ai_wants_raise_cossack',
    13894: 'legitimacy_equivalent',
    13895: 'has_government_mechanic',
    13896: 'current_institution_growth',
    13897: 'has_government_power',
    13898: 'uses_devotion',
    13899: 'martin_trigger12',
    13900: 'martin_trigger13',
    13901: 'martin_trigger14',
    13902: 'martin_trigger15',
    13903: 'martin_trigger16',
    13904: 'martin_trigger17',
    13905: 'martin_trigger18',
    13906: 'martin_trigger19',
    13907: 'martin_trigger20',
    13908: 'allow_force_tributary',
    13909: 'local_monthly_devastation',
    13911: 'any_state',
    13912: 'all_states',
    13913: 'in_golden_age',
    13914: 'num_of_banners',
    13915: 'num_of_harmonized',
    13916: 'add_trust',
    13917: 'gets_help_with_rebels',
    13918: 'allows_taking_land_without_independence',
    13919: 'share_rebel_popup',
    13920: 'is_potential_overlord',
    13921: 'can_be_established',
    13922: 'scriptable_diplomatic_action',
    13923: 'on_accept',
    13924: 'on_decline',
    13925: 'on_cancel',
    13926: 'is_visible',
    13927: 'is_allowed',
    13928: 'action_type',
    13929: 'static_actions',
    13930: 'alert_index',
    13931: 'alert_tooltip',
    13932: 'require_acceptance',
    13933: 'ai_acceptance',
    13934: 'add_entry',
    13935: 'use_colonial_ui',
    13936: 'use_vassal_ui',
    13937: 'use_union_ui',
    13938: 'use_march_ui',
    13939: 'construct_colonial',
    13940: 'construct_vassal',
    13941: 'construct_union',
    13942: 'construct_march',
    13944: 'local_friendly_movement_speed',
    13945: 'local_hostile_movement_speed',
    13946: 'imperial_authority_value',
    13947: 'war_taxes_cost_modifier',
    13948: 'siege_blockade_progress',
    13949: 'warscore_cost_vs_other_religion',
    13950: 'mercenary_discipline',
    13951: 'end_incident',
    13952: 'is_dynamic_tag',
    13953: 'remove_advisor_by_category',
    13954: 'neighboring_other_religion',
    13955: 'set_treasury_command',
    13956: 'keep_treaties',
    13959: 'wants_join_hre',
    13960: 'add_adm_tech',
    13961: 'add_dip_tech',
    13962: 'add_mil_tech',
    13963: 'revanchism',
    13964: 'indestructible',
    13965: 'add_active_policy',
    13966: 'had_active_policy',
    13967: 'add_next_institution_embracement',
    13968: 'can_transfer_in_peace',
    13969: 'colonial_region_nations',
    13970: 'ai_wont_abdicate',
    13971: 'with',
    13972: 'restoration_cb',
    13973: 'can_set_mil_focus',
    13974: 'can_be_overlord',
    13975: 'power_cost_base',
    13976: 'prestige_base',
    13977: 'ae_base',
    13978: 'warscore_cost',
    13979: 'requires_demand_independence',
    13980: 'warscore_cap',
    13981: 'is_make_subject',
    13982: 'requires_is_allowed',
    13983: 'ai_weight',
    13984: 'all_provinces',
    13985: 'no_provinces',
    13986: 'owner_keeps',
    13987: 'conquered',
    13988: 'separatists_become_subjects',
    13989: 'is_null',
    13990: 'num_of_streltsy',
    13991: 'streltsy_infantry',
    13992: 'may_establish_frontier',
    13993: 'siberian_frontier',
    13994: 'has_state_patriach',
    13995: 'consecrate_patriarch_command',
    13996: 'orthodox_icons',
    13997: 'current_icon',
    13998: 'icon_start_date',
    13999: 'commission_icon',
    14000: 'government_abilities',
    14001: 'russian_pool',
    14002: 'martin_token_122',
    14003: 'martin_token_123',
    14004: 'martin_token_124',
    14005: 'martin_token_125',
    14006: 'claim_states',
    14007: 'num_of_cossacks',
    14008: 'cossack_cavalry',
    14009: 'lacked_sailors',
    14010: 'sailor_maintenance_modifer',
    14011: 'uses_religious_icons',
    14012: 'idea_may_siberian_frontier',
    14013: 'monthly_piety',
    14014: 'monthly_karma',
    14015: 'local_culture_conversion_cost',
    14016: 'development_of_overlord_fraction',
    14017: 'add_siberian_construction',
    14019: 'province_distance',
    14020: 'can_create_trading_city',
    14021: 'accumulated_card_score',
    14022: 'use_heir_as_leader',
    14023: 'use_consort_as_leader',
    14024: 'heir_culture',
    14025: 'consort_culture',
    14026: 'ruler_culture',
    14027: 'heir_religion',
    14028: 'consort_religion',
    14029: 'ruler_religion',
    14030: 'set_heir_culture',
    14031: 'set_consort_culture',
    14032: 'set_ruler_culture',
    14033: 'set_heir_religion',
    14034: 'set_consort_religion',
    14035: 'set_ruler_religion',
    14036: 'released_nation',
    14037: 'cancelled_subject',
    14038: 'army_professionalism',
    14039: 'incident_variables',
    14040: 'id_counters',
    14041: 'cores',
    14042: 'claims',
    14043: 'persistent_attackers',
    14044: 'persistent_defenders',
    14045: 'electors',
    14046: 'active_loyalties',
    14047: 'active_influences',
    14048: 'quit_on_oos',
    14049: 'max_ticks_ahead',
    14050: 'recalc_defection',
    14051: 'client_went_oos_command',
    14052: 'shutdown_client_command',
    14053: 'random_log_stack_depth',
    14054: 'monthly_war_exhaustion',
    14055: 'rebel_name',
    14056: 'is_invading',
    14057: 'traded',
    14058: 'ub',
    14059: 'add_army_professionalism',
    14060: 'spy_actions',
    14061: 'buildings',
    14062: 'personalities',
    14063: 'parliament',
    14064: 'trade_embargoes',
    14065: 'map_area_data',
    14066: 'supply_depots',
    14067: 'build_supply_depot',
    14068: 'has_professionalism_modifier',
    14069: 'set_army_professionalism',
    14070: 'may_build_supply_depot',
    14071: 'refill_garrison',
    14072: 'may_refill_garrison',
    14073: 'feudal_theocracy_mechanic',
    14074: 'russian_mechanic',
    14075: 'add_government_power',
    14076: 'yearly_army_professionalism',
    14077: 'government_interaction_command',
    14078: 'government_mechanic',
    14079: 'marker_sprite',
    14080: 'iqta_mechanic',
    14081: 'mamluk_mechanic',
    14082: 'tribal_federation_mechanic',
    14083: 'sanction_holy_war',
    14084: 'invite_minorities',
    14085: 'seize_clerical_holdings',
    14086: 'train_horsemanship',
    14087: 'tribal_allegiance',
    14088: 'yearly_tribal_allegiance',
    14089: 'drill',
    14090: 'drill_army_mission',
    14091: 'drill_gain_modifier',
    14093: 'can_union_break',
    14094: 'add_tribal_allegiance',
    14095: 'same_culture_advisor_cost',
    14097: 'on_built',
    14098: 'on_destroyed',
    14099: 'on_obsolete',
    14100: 'may_return_manpower_on_disband',
    14101: 'general_cost',
    14102: 'reserves_organisation',
    14103: 'unit_sprite_start',
    14104: 'religious_schools',
    14105: 'potential_invite_scholar',
    14106: 'can_invite_scholar',
    14107: 'on_invite_scholar',
    14108: 'else_if',
    14109: 'religious_school',
    14110: 'religion_sub_modifier',
    14111: 'tbk',
    14112: 'write_late_oos_files_command',
    14113: 'invite_scholar_modifier_display',
    14114: 'ai_data',
    14115: 'invite_scholar',
    14116: 'school',
    14117: 'wants_to_be_great_power_next',
    14118: 'power_balance_threat_cache',
    14119: 'strength_damage',
    14120: 'morale_damage',
    14121: 'religion_instance_data',
    14122: 'hate',
    14123: 'ambivalent',
    14124: 'like',
    14125: 'total_privateer_power',
    14126: 'uses_religious_schools',
    14127: 'has_religious_school',
    14128: 'overrun',
    14129: 'already_sent',
    14130: 'privateer_money',
    14131: 'score_place',
    14132: 'gamesetup_players',
    14133: 'has_religious_school_of',
    14134: 'rnw_seed',
    14135: 'cached_colonies',
    14136: 'school_opinion',
    14137: 'set_school_opinion',
    14138: 'set_religious_school',
    14139: 'rebels_in_country',
    14140: 'government_name',
    14141: 'movement_locked',
    14142: 'delete_id',
    14143: 'delete_navy',
    14144: 'delete_army',
    14145: 'unit_manager',
    14146: 'use_compact_battle_result',
    14147: 'can_select',
    14148: 'button_gfx',
    14149: 'center_of_reformation',
    14150: 'select_trading_policy',
    14151: 'trading_policy',
    14152: 'trading_policy_date',
    14153: 'node_province_modifier',
    14154: 'countries_with_merchant_modifier',
    14155: 'at_war_with_other_religious_group',
    14156: 'is_node_in_trade_company_region',
    14157: 'spawned',
    14158: 'trade_company_manager',
    14159: 'ai_will_propagate_through_trade',
    14163: 'perform_action',
    14164: 'perform_action_status',
    14165: 'perform_action_province',
    14169: 'trader_has_active_policy',
    14170: 'trading_policy_in_node',
    14171: 'expire_message_type',
    14172: 'go_to',
    14173: 'target_province_weights',
    14174: 'base_conversion_speed',
    14175: 'trader',
    14176: 'map_icon',
    14177: 'last_impact',
    14178: 'impact',
    14179: 'building_builders',
    14180: 'can_maintain',
    14181: 'can_send_missionary_to_subject',
    14182: 'has_pashas',
    14183: 'has_state_pasha',
    14184: 'add_pasha_command',
    14185: 'started_combat',
    14186: 'max_historic_army_professionalism',
    14187: 'rebel_home_country',
    14188: 'rebel_type',
    14190: 'has_saved_name',
    14191: 'set_saved_name',
    14192: 'clear_saved_name',
    14193: 'simple',
    14194: 'saved_names',
    14195: 'foreign_slave_rulers',
    14196: 'hide_skills',
    14197: 'promote_culture_cost',
    14198: 'knowledge_sharing',
    14199: 'po_steer_trade',
    14200: 'steer_trade',
    14201: 'institution_growth',
    14202: 'hostile_core_creation_tag',
    14203: 'hostile_core_creation_desc',
    14204: 'hostile_core_creation_cost',
    14205: 'martin_token10',
    14206: 'martin_token11',
    14207: 'martin_token12',
    14208: 'martin_token13',
    14209: 'martin_token14',
    14210: 'martin_token15',
    14211: 'martin_token16',
    14212: 'martin_token17',
    14213: 'martin_token18',
    14214: 'transfer_subjects_when_made',
    14215: 'exploit_development',
    14216: 'use_low_piety',
    14217: 'use_high_piety',
    14218: 'exploit_date',
    14219: 'promote_advisor',
    14220: 'loaded_on',
    14222: 'slacken_recruiting_standards',
    14223: 'create_janissaries_command',
    14224: 'is_janissary_modifier',
    14225: 'is_date',
    14226: 'monarch_consort',
    14227: 'monarch_heir',
    14228: 'monarch_foreign_heir',
    14229: 'any_controlled_province',
    14230: 'all_controlled_province',
    14231: 'has_supply_depot',
    14232: 'janissary_percentage',
    14233: 'num_of_janissaries',
    14234: 'has_pasha',
    14235: 'num_of_different_religions_in_court',
    14236: 'num_of_different_cultures_in_court',
    14237: 'num_of_regiments_at_full_drill',
    14238: 'extend_province_modifier',
    14239: 'country_indices',
    14240: 'general_with_steam_name',
    14241: 'from_ruler',
    14242: 'unit_owner',
    14243: 'any_army',
    14244: 'show_alert',
    14245: 'power_modifier',
    14246: 'target_provinces_list',
    14247: 'target_areas_list',
    14248: 'target_colonial_region_list',
    14249: 'target_trade_company_region_list',
    14250: 'target_trade_node_list',
    14251: 'team',
    14252: 'is_scholar_modifier',
    14254: 'random_trade_node_locations',
    14255: 'attrition_level',
    14256: 'num_collectors',
    14257: 'set_custom_country_gfx_culture_command',
    14258: 'set_custom_country_religion_command',
    14259: 'set_custom_country_culture_command',
    14260: 'set_custom_country_technology_group_command',
    14261: 'personality_index',
    14262: 'ruler_type',
    14264: 'last_janissary_spawn',
    14265: 'set_oos_checks_command',
    14266: 'add_province_triggered_modifier',
    14267: 'teams',
    14268: 'create_team',
    14269: 'load_file',
    14270: 'request_file',
    14271: 'join_team',
    14272: 'border_distance_indexed',
    14273: 'border_distance_overseas_indexed',
    14274: 'countries_max_demand',
    14275: 'adm_spent_indexed',
    14276: 'dip_spent_indexed',
    14277: 'mil_spent_indexed',
    14278: 'num_of_buildings_under_construction_indexed',
    14279: 'num_of_buildings_indexed',
    14280: 'num_of_religions_indexed',
    14281: 'num_of_subject_count_indexed',
    14282: 'dead_roc',
    14283: 'synch_teams',
    14284: 'remove_province_triggered_modifier',
    14285: 'on_activation',
    14286: 'on_deactivation',
    14287: 'applied_triggered_modifier',
    14288: 'triggered_modifier',
    14289: 'drill_decay_modifier',
    14290: 'been_told_of_low_vram',
    14291: 'decision_seed',
    14292: 'num_of_religions_dev',
    14293: 'dominant_religion_by_provinces',
    14294: 'num_of_centers_of_reformation',
    14295: 'dismissed_news_banner',
    14296: 'link_button_text',
    14297: 'link_url',
    14298: 'steam_depot_id',
    14299: 'is_latent',
    14300: 'latent_trade_goods',
    14301: 'add_latent_trade_goods',
    14302: 'provincial_institution_progress',
    14303: 'has_latent_trade_goods',
    14304: 'remove_latent_trade_goods',
    14305: 'change_innovativeness',
    14306: 'innovativeness',
    14307: 'tech_level_dates',
    14308: 'active_missions',
    14309: 'slot',
    14310: 'complete_mission',
    14311: 'completed_missions',
    14312: 'required_missions',
    14313: 'has_country_shield',
    14314: 'generic',
    14315: 'grown_by_development',
    14316: 'grown_by_states',
    14317: 'num_of_non_tributary_subjects',
    14318: 'swap_non_generic_missions',
    14319: 'historic_stats_cache',
    14320: 'starting_development',
    14321: 'starting_num_of_states',
    14322: 'completed_by',
    14323: 'region_for_scope_province',
    14324: 'country_modifier',
    14325: 'naval_doctrine',
    14326: 'show_separate',
    14327: 'idea_dates',
    14328: 'area_for_scope_province',
    14329: 'is_valuable',
    14330: 'is_in_large_debt',
    14331: 'own_coast_naval_combat_bonus',
    14333: 'rnw_latent_chance',
    14334: 'aspects_name',
    14335: 'mission_completed',
    14336: 'island_check_provinces',
    14339: 'uses_anglican_power',
    14340: 'num_of_foreign_hre_provinces',
    14341: 'num_of_consorts',
    14342: 'keep_subjects',
    14343: 'starting_income',
    14344: 'share_of_starting_income',
    14345: 'country_missions',
    14346: 'mission_slot',
    14347: 'has_mission',
    14348: 'ai_priority',
    14349: 'innovativeness_gain',
    14350: 'show_duration',
    14351: 'provinces_to_highlight',
    14352: 'has_active_triggered_province_modifier',
    14353: 'is_capital_of',
    14354: 'province_is_on_an_island',
    14355: 'separatists_target',
    14356: 'save_interval',
    14357: 'mapmode_screenshot_interval',
    14358: 'mapmode_id',
    14359: 'interval',
    14360: 'potential_on_load',
    14361: 'was_tag',
    14362: 'friend_tags',
    14363: 'call_to_arms_friends',
    14364: 'infantry_soldiers',
    14365: 'infantry_weapons',
    14366: 'elephants',
    14367: 'tech_level',
    14368: 'government_reform_progress',
    14369: 'country_state',
    14370: 'states',
    14371: 'change_government_reform_progress',
    14372: 'modifiers',
    14373: 'reforms',
    14374: 'reform_levels',
    14375: 'tech_level_effects',
    14376: 'sea',
    14377: 'tag_specific_effects',
    14378: 'default_effect',
    14379: 'specific_effect',
    14380: 'cost_multiplier',
    14381: 'raise_war_taxes',
    14382: 'fixed_interest',
    14383: 'add_loan',
    14384: 'interest_modifier',
    14385: 'num_of_rajput',
    14386: 'rajput_infantry',
    14387: 'is_rajput_modifier',
    14388: 'ai_wants_raise_rajput',
    14389: 'tradition',
    14390: 'add_fire',
    14391: 'add_shock',
    14392: 'add_siege',
    14393: 'add_manuever',
    14394: 'possible_policy',
    14395: 'free_policy',
    14396: 'possible_adm_policy',
    14397: 'possible_dip_policy',
    14398: 'possible_mil_policy',
    14399: 'free_adm_policy',
    14400: 'free_dip_policy',
    14401: 'free_mil_policy',
    14402: 'adm_advisor_cost',
    14403: 'dip_advisor_cost',
    14404: 'mil_advisor_cost',
    14405: 'transports',
    14406: 'light_ships',
    14407: 'heavy_ships',
    14408: 'stability_hit_on_war',
    14409: 'factions',
    14410: 'basic_reform',
    14411: 'legacy_government',
    14412: 'done_at_start',
    14414: 'select_government_reform',
    14415: 'add_government_reform',
    14416: 'remove_government_reform',
    14417: 'government_reform',
    14418: 'has_reform',
    14419: 'change_to_government_reform',
    14420: 'change_legacy_government',
    14421: 'assimilation_cultures',
    14422: 'set_legacy_government',
    14425: 'reform_progress_growth',
    14427: 'reform_stack',
    14428: 'change_for_corruption_effect',
    14429: 'select_for_points_effect',
    14430: 'removed_effect',
    14431: 'lock_level_when_selected',
    14432: 'lose_reforms',
    14433: 'legacy_equivalent',
    14434: 'min_autonomy_in_territories',
    14435: 'reelection_cost',
    14436: 'leader_cost',
    14437: 'candidate_random_bonus',
    14438: 'charter_company',
    14439: 'equator_y_on_province_image',
    14440: 'mild_monsoon',
    14441: 'normal_monsoon',
    14442: 'severe_monsoon',
    14443: 'starting_reform',
    14444: 'num_investments_in_trade_company_region',
    14445: 'upgrades_to',
    14446: 'owner_modifier',
    14448: 'company_province_area_modifier',
    14449: 'area_modifier',
    14451: 'investment',
    14452: 'investments',
    14453: 'forcelimit_to_overlord',
    14454: 'monsoon',
    14455: 'creator',
    14456: 'make_trade_company_investment',
    14457: 'has_monsoon',
    14458: 'special_unit_culture',
    14459: 'compare_regiments_to_province_of_estate',
    14460: 'compare',
    14461: 'banner_regiment',
    14462: 'streltsy_regiment',
    14463: 'cossacks_regiment',
    14464: 'janissries_regiment',
    14465: 'rajput_regiment',
    14466: 'equal',
    14467: 'less',
    14468: 'more',
    14469: 'remove_team',
    14470: 'normal_regiment',
    14471: 'mercenary_regiment',
    14472: 'election_cycle',
    14473: 'state_modifiers',
    14474: 'global_modifiers',
    14475: 'coastal',
    14476: 'has_trade_company_investment_in_area',
    14477: 'investor',
    14478: 'owner_company_region_modifier',
    14479: 'random_gender',
    14480: 'home_trade_node_effect_scope',
    14481: 'states_general_mechanic',
    14482: 'statists_vs_monarchists',
    14483: 'change_statists_vs_monarchists',
    14484: 'is_monarchists_in_power',
    14485: 'has_states_general_mechanic',
    14486: 'is_reform_available',
    14487: 'specific_effect_trigger',
    14488: 'has_exclusive_government_reform',
    14489: 'rename_team',
    14490: 'center_of_trade',
    14491: 'modify_center_of_trade',
    14492: 'country_has_center_of_trade_of_level',
    14493: 'num_of_centers_of_trade',
    14494: 'add_center_of_trade_level',
    14495: 'set_center_of_trade_level',
    14496: 'add_trade_company_investment',
    14497: 'exclusive_reforms',
    14498: 'settlement_growth_construction',
    14499: 'custom_attributes',
    14500: 'has_government_attribute',
    14501: 'trade_city_reform',
    14502: 'ai_area_worth',
    14503: 'ai_region_worth',
    14504: 'ai_global_worth',
    14505: 'province_has_center_of_trade_of_level',
    14506: 'have_had_reform',
    14507: 'cossacks_mechanic',
    14508: 'has_privateer_share_in_trade_node',
    14509: 'play_as',
    14510: 'total_losses_in_won_wars',
    14511: 'winner',
    14512: 'looser',
    14513: 'casualties',
    14515: 'level_1_center_of_trade',
    14516: 'level_2_center_of_trade',
    14517: 'level_3_center_of_trade',
    14518: 'outcome',
    14519: 'conditional',
    14520: 'adopt_reform_progress',
    14521: 'post_enact_effect',
    14522: 'start_territory_weight',
    14523: 'start_territory_to_estates',
    14524: 'current_bribe',
    14525: 'has_reform_level',
    14526: 'allow_normal_conversion',
    14527: 'player_uuid',
    14528: 'pre_dharma_mapping',
    14529: 'all_countries_including_self',
    14530: 'add_years_of_manpower_scaled_to_seats',
    14531: 'add_years_of_sailors_scaled_to_seats',
    14532: 'add_years_of_tax_scaled_to_seats',
    14533: 'add_prestige_scaled_to_seats',
    14534: 'add_militarization_scaled_to_seats',
    14535: 'leave_team',
    14536: 'has_government_attribute_short_desc',
    14537: 'native',
    14538: 'map_setup',
    14539: 'map_setup_normal',
    14540: 'map_setup_historical',
    14541: 'map_setup_random',
    14542: 'map_setup_custom',
    14543: 'amount_of_provinces',
    14544: 'company_region_modifier',
    14545: 'on_start_effect',
    14546: 'fake_player_country',
    14547: 'define_exiled_ruler',
    14548: 'exiled_as',
    14549: 'clear_exiled_ruler',
    14550: 'exiled_same_dynasty_as_current',
    14551: 'full_dump',
    14552: 'enacted_parliament_issue',
    14553: 'tracked_events',
    14555: 'reason',
    14556: 'monthly_support_heir_gain',
    14557: 'power_projection_from_insults',
    14558: 'election_on_death',
    14559: 'grow_institution',
    14560: 'has_unembraced_institution',
    14561: 'add_next_institution_embracement_scaled',
    14562: 'adm_power_cost',
    14563: 'dip_power_cost',
    14564: 'mil_power_cost',
    14565: 'vc_age_score',
    14566: 'max_age',
    14567: 'min_age',
    14568: 'seen_legal_documents',
    14569: 'rich_presence',
    14570: 'every_neighbor_sea_zone',
    14571: 'set_base_tax',
    14572: 'set_base_production',
    14573: 'set_base_manpower',
    14574: 'local_religious_unity_contribution',
    14575: 'may_convert_territories',
    14576: 'needs_money',
    14577: 'space_bear_invasion',
    14578: 'synthetic_dawn',
    14579: 'has_term_election',
    14580: 'all_your_core_are_belong_to_us',
    14581: 'eval_add',
    14582: 'eval_multiply',
    14583: 'eval_overwrite',
    14584: 'has_hostile_troops',
    14585: 'holy_order',
    14586: 'per_province_effect',
    14587: 'establish_holy_order',
    14588: 'cost_trigger',
    14589: 'is_captured',
    14590: 'modification',
    14591: 'number_of_cannons_flagship_modifier',
    14592: 'number_of_cannons_flagship',
    14593: 'naval_maintenance_flagship_modifier',
    14594: 'trade_power_in_fleet_modifier',
    14596: 'flagship_naval_engagement_modifier',
    14597: 'blockade_impact_on_siege_in_fleet_modifier',
    14598: 'movement_speed_in_fleet_modifier',
    14599: 'flagship_durability',
    14600: 'morale_in_fleet_modifier',
    14601: 'exploration_mission_range_in_fleet_modifier',
    14602: 'barrage_cost_in_fleet_modifier',
    14603: 'naval_attrition_in_fleet_modifier',
    14604: 'cannons_for_hunting_pirates_in_fleet',
    14605: 'trade_company_investment_cost',
    14606: 'dlcs_required',
    14607: 'requires_country_state',
    14608: 'banners',
    14609: 'patriarch',
    14610: 'pasha',
    14611: 'count_one_per_area',
    14612: 'trade_company_efficiency',
    14613: 'minority_expulsion',
    14614: 'expulsion_province',
    14615: 'expelling_minorities',
    14616: 'expulsion_target',
    14617: 'force_admiral_leader',
    14618: 'convert_ruler_to_admiral',
    14619: 'convert_female_ruler_to_admiral',
    14620: 'convert_heir_to_admiral',
    14621: 'convert_female_heir_to_admiral',
    14622: 'num_of_owned_states_with',
    14624: 'flagship',
    14625: 'enabled_free_dlcs',
    14626: 'cost_type',
    14627: 'establish_order_cost',
    14628: 'may_perform_slave_raid_on_same_religion',
    14629: 'most_recent_treasure_ship_passage',
    14630: 'recent_treasure_ship_passage',
    14631: 'native_policy_none',
    14632: 'native_policy_coexist',
    14633: 'native_policy_trade',
    14634: 'native_policy_hostile',
    14635: 'treasure_fleet_income',
    14636: 'has_flagship',
    14637: 'can_establish_order',
    14638: 'center_of_trade_upgrade_cost',
    14639: 'missionary_maintenance_cost',
    14640: 'naval_tradition_from_trade',
    14641: 'admiral_cost',
    14642: 'expel_minorities_cost',
    14643: 'can_fabricate_for_vassals',
    14644: 'create_named_ship',
    14645: 'create_flagship',
    14646: 'global_naval_barrage_cost',
    14647: 'global_blockade_impact_on_siege',
    14648: 'local_missionary_maintenance_cost',
    14649: 'overlord_can_fabricate_for',
    14650: 'admirals_become_rulers',
    14651: 'disallowed_trade_goods',
    14652: 'generals_become_rulers',
    14653: 'ai_trade_score',
    14654: 'ai_war_score',
    14655: 'factions_frame',
    14656: 'per_province_abandon_effect',
    14657: 'expelled_different_minorities',
    14658: 'expelling_minorities_from',
    14659: 'total_pips',
    14660: 'base_modification',
    14661: 'flagship_landing_penalty',
    14662: 'movement_speed_onto_off_boat_modifier',
    14663: 'admiral_skill_gain_modifier',
    14665: 'prestige_from_battles_in_fleet_modifier',
    14666: 'naval_tradition_in_fleet_modifier',
    14667: 'global_supply_limit_modifier',
    14668: 'holy_order_founder',
    14669: 'flagship_morale',
    14670: 'custom_country_set_idea_group_command',
    14671: 'has_disengaged',
    14672: 'owns_all_provinces',
    14673: 'allow_banners',
    14674: 'has_non_generic_missions',
    14675: 'show_header',
    14676: 'show_example_image',
    14677: 'show_example_image_tooltips',
    14678: 'hide_if_unowned',
    14679: 'change_landingpage',
    14680: 'hide_if_dlc_owned',
    14681: 'recommendations',
    14682: 'required_dlc',
    14683: 'default_category',
    14685: 'tooltip_desc',
    14686: 'tooltip_reason',
    14687: 'show_in_expansion_list',
    14689: 'has_country_list',
    14690: 'has_example_image',
    14692: 'development_in_provinces',
    14693: 'test_versions',
    14694: 'province_getting_expelled_minority',
    14695: 'is_ruler_commanding_unit',
    14696: 'clear_rebels',
    14697: 'on_progress_effect',
    14698: 'user_status',
    14699: 'skip_account_link',
    14700: 'set_campaign_id',
    14701: 'boost_states',
    14702: 'num_of_boost_states',
    14703: 'po_join_empire',
    14704: 'bound_to_empire',
    14705: 'reform_progress_growth_building',
    14706: 'provoke_revolt',
    14707: 'influence_from_dev_modifier',
    14708: 'contributes_to_curia_treasury',
    14709: 'task_requirements',
    14710: 'on_granted',
    14711: 'agendas',
    14712: 'privileges',
    14713: 'change_estate_land_share',
    14714: 'grant_privilege',
    14715: 'granted_privileges',
    14716: 'revoke_privilege',
    14717: 'crown_land_interaction',
    14718: 'range_from',
    14719: 'range_to',
    14720: 'agenda',
    14721: 'completed',
    14722: 'active_agenda',
    14723: 'create_new_estate_agenda',
    14725: 'on_revoked',
    14726: 'has_estate_privilege',
    14727: 'can_revoke',
    14728: 'force_converted_by',
    14729: 'crown_land_share',
    14730: 'estate_loan',
    14731: 'has_estate_loan',
    14732: 'is_supporting_independence_of',
    14733: 'num_of_buildings_in_province',
    14734: 'monthly_adm',
    14735: 'monthly_dip',
    14736: 'monthly_mil',
    14737: 'num_of_times_improved_by_owner',
    14738: 'country_improve_count',
    14739: 'is_renting_condottieri_to',
    14740: 'mercenary_fraction',
    14741: 'higher_development_than',
    14742: 'has_had_golden_age',
    14743: 'trade_goods_produced_amount',
    14744: 'council_active',
    14745: 'is_council_enabled',
    14746: 'enable_council',
    14747: 'concilatory',
    14748: 'harsh',
    14749: 'neutral',
    14750: 'set_council_position',
    14751: 'concessions',
    14752: 'set_council_concession',
    14753: 'historical_council',
    14754: 'assign_heir',
    14755: 'emperor_temp_rickard_24',
    14756: 'emperor_temp_rickard_25',
    14757: 'mercenary_company',
    14758: 'mercenary_companies',
    14759: 'hiring_date',
    14760: 'disband_date',
    14761: 'hire_company',
    14762: 'regiments_per_development',
    14763: 'cavalry_weight',
    14764: 'artillery_weight',
    14765: 'home_province',
    14766: 'cost_modifier',
    14767: 'starting_manpower',
    14768: 'random_hired_mercenary_company',
    14769: 'disband_mercenary_company',
    14770: 'any_hired_mercenary_company',
    14771: 'is_foreign_company',
    14773: 'num_of_hired_mercenary_companies',
    14774: 'template',
    14775: 'kill_mercenary_leader',
    14776: 'is_mercenary_modifier',
    14777: 'hire_special_regiment',
    14778: 'has_company_manpower',
    14779: 'add_company_manpower',
    14780: 'revolution',
    14781: 'revolution_province_modifiers',
    14782: 'curia_treasury',
    14783: 'curia_treasury_contribution',
    14784: 'call_ecumenical_council',
    14785: 'appoint_cardinal',
    14786: 'buy_indulgence',
    14787: 'mechanics',
    14788: 'pick_golden_bull',
    14789: 'curia_powers_cost',
    14790: 'imperial_reform_catholic_approval',
    14791: 'unrest_catholic_provinces',
    14792: 'appoint_cardinal_cost',
    14793: 'curia_treasury_size',
    14794: 'curia_treasury_income',
    14795: 'add_curia_treasury',
    14796: 'is_lacking_institutions',
    14797: 'golden_bull',
    14798: 'wants_to_appoint_cardinals_in_his_own_land',
    14799: 'is_defender_of_faith_of_tier',
    14800: 'manpower_in_true_faith_provinces',
    14801: 'same_faith_modifier',
    14802: 'spend_money',
    14803: 'spending_post',
    14804: 'command',
    14805: 'wants_ecumenical_council',
    14806: 'tracked_tags',
    14807: 'continents',
    14808: 'modifier_definition',
    14809: 'named_unrest',
    14810: 'add_named_unrest',
    14811: 'inverse_crown_land',
    14812: 'crown_land',
    14814: 'is_most_powerful_estate',
    14815: 'apply_sprite_pack',
    14816: 'cooldown_years',
    14817: 'on_cooldown_expires',
    14818: 'can_revoke_estate_privilege',
    14819: 'short',
    14820: 'fallback',
    14821: 'generate_estate_agenda',
    14822: 'clear_estate_agenda_cache',
    14823: 'active_agenda_cache',
    14824: 'random_seed',
    14825: 'mercenary_manpower',
    14826: 'penalties',
    14827: 'benefits',
    14828: 'is_bad',
    14829: 'remove_advisor_by_category_no_action',
    14830: 'emperor_per_prince',
    14831: 'higher_than_influence',
    14832: 'enemy_unit',
    14833: 'sprite_infantry',
    14834: 'country_trigger',
    14835: 'graphical_cultures',
    14836: 'sprite_cavalry',
    14837: 'sprite_artillery',
    14843: 'sprite_packs',
    14844: 'set_estate_privilege',
    14845: 'remove_estate_privilege',
    14846: 'conditional_modifier',
    14847: 'modifier_by_land_ownership',
    14848: 'country_admin_power',
    14849: 'country_diplomatic_power',
    14850: 'country_military_power',
    14851: 'yearly_patriarch_authority',
    14852: 'yearly_karma_decay',
    14853: 'available_province_loot',
    14854: 'stability_cost_to_declare_war',
    14855: 'exempt_from_seize_land',
    14856: 'can_veto_heirs',
    14857: 'enables_cossack_regiments',
    14858: 'enables_rajput_regiments',
    14859: 'special_unit_forcelimit',
    14860: 'vassal_liberty_affected_by_loyalty',
    14861: 'can_give_agendas_without_interaction',
    14862: 'add_years_of_owned_provinces_production_income',
    14863: 'is_valid',
    14864: 'emperor_temp_michael_46',
    14865: 'start_estate_agenda',
    14866: 'effect_when_unhappy',
    14867: 'province_independence_weight',
    14868: 'has_active_estate_agenda',
    14869: 'failing_effect',
    14870: 'task_completed_effect',
    14871: 'pre_effect',
    14872: 'num_of_estate_privileges',
    14873: 'num_of_estate_agendas_completed',
    14874: 'veto_current_heir',
    14875: 'selection_weight',
    14876: 'fail_if',
    14877: 'missionary_strength',
    14878: 'join_hre',
    14879: 'required_reform',
    14880: 'passed_reforms',
    14881: 'passed_reform',
    14882: 'empire_of_china_reform_passed',
    14883: 'hre_reform_passed',
    14884: 'gui_container',
    14885: 'disabled_by',
    14886: 'max_days_active',
    14887: 'active_incident',
    14888: 'active_imperial_incident',
    14889: 'set_imperial_incident',
    14890: 'default_option',
    14891: 'pick_imperial_incident_option',
    14892: 'normal_regiment_percentage',
    14893: 'mercenary_percentage',
    14894: 'banner_percentage',
    14895: 'streltys_percentage',
    14896: 'cossacks_percentage',
    14897: 'rajput_percentage',
    14898: 'free_city_imperial_authority',
    14899: 'imperial_mercenary_cost',
    14900: 'max_free_cities',
    14901: 'max_electors',
    14902: 'manpower_against_imperial_enemies',
    14903: 'affected_nations',
    14904: 'join_all_defensive_wars_of',
    14905: 'join_all_offensive_wars_of',
    14906: 'emperor_temp_michael_88',
    14907: 'monarch_lifespan',
    14908: 'revoke_imperial_reform',
    14909: 'emperor_has_revoked',
    14910: 'on_invalid',
    14911: 'manage_estates',
    14912: 'emperor_temp_michael_94',
    14913: 'emperor_temp_michael_95',
    14914: 'emperor_temp_michael_96',
    14915: 'emperor_temp_michael_97',
    14916: 'emperor_temp_michael_98',
    14917: 'emperor_temp_michael_99',
    14918: 'disengagement_chance',
    14919: 'zeal_modifiers',
    14920: 'past_targets',
    14921: 'embrace_revolution',
    14922: 'revolution_development',
    14923: 'liberty_desire_revolution',
    14924: 'po_spread_revolution',
    14925: 'is_center_of_revolution',
    14926: 'has_revolution_in_province',
    14927: 'revolution_spread',
    14928: 'set_revolution_in_province',
    14929: 'can_embrace_revolution',
    14930: 'revolutionary_zeal',
    14931: 'max_revolutionary_zeal',
    14932: 'yearly_revolutionary_zeal',
    14933: 'uses_revolutionary_zeal',
    14934: 'add_revolutionary_zeal',
    14935: 'emperor_previous_rank',
    14936: 'spawn_center_of_revolution',
    14937: 'remove_center_of_revolution',
    14938: 'revolutionary',
    14939: 'is_revolutionary',
    14940: 'max_years_since',
    14941: 'has_won_war_against',
    14942: 'flagship_cost',
    14943: 'is_coalition',
    14944: 'name_override_key',
    14945: 'override_country_name',
    14946: 'restore_country_name',
    14947: 'previous_incident',
    14948: 'set_hre_status',
    14949: 'hre_status_gfx_key',
    14950: 'hre_status_loc_key',
    14951: 'is_hegemon',
    14952: 'claim_hegemony',
    14953: 'is_imperial_modifier',
    14954: 'elector_per_prince',
    14955: 'imperial_realm_war_action',
    14956: 'imperial_realm_war',
    14957: 'enable_imperial_realm_war',
    14958: 'call_empire_members',
    14959: 'available_for_custom_nation',
    14960: 'add_years_of_estate_land_income',
    14961: 'num_of_owned_areas',
    14962: 'curia_treasury_cost',
    14963: 'add_reform_desire_scale',
    14964: 'reform_desire_scale',
    14965: 'bonus_manufactory',
    14966: 'bonus_modifier',
    14967: 'is_revolutionary_guard_modifier',
    14968: 'invalid_trigger',
    14969: 'ended_by_country_breaking_to_rebels',
    14970: 'rebel_target_country',
    14971: 'is_rebel_type',
    14972: 'years_since_dismantle_revolution',
    14973: 'dismantle_date',
    14974: 'claim_revolution_target',
    14975: 'low_zeal_since',
    14976: 'support_independence_of',
    14977: 'add_power_projection',
    14978: 'is_hiring_condottiere_from',
    14979: 'humiliated_by',
    14980: 'blockade_force_required',
    14981: 'hostile_disembark_speed',
    14982: 'hostile_slave_raid_efficiency',
    14983: 'hostile_fleet_attrition',
    14984: 'num_of_marines',
    14985: 'marine_infantry',
    14986: 'allowed_marine_fraction',
    14987: 'end_game_tags_blocked',
    14988: 'use_monarch_as_leader',
    14989: 'relation_with_heretics',
    14990: 'expand_administration_cost',
    14991: 'num_expanded_administration',
    14992: 'trade_company_governing_cost',
    14993: 'state_governing_cost',
    14994: 'territories_governing_cost',
    14995: 'block_settlement_growth',
    14996: 'allow_settlement_growth',
    14997: 'legitimate_subject_elector',
    14998: 'accept_vassalization_reasons',
    14999: 'transfer_trade_power_reasons',
    15000: 'local_warscore_cost_modifier',
    15001: 'mercantilism_cost',
    15002: 'is_all_concessions_in_council_taken',
    15003: 'council_finished',
    15004: 'council_position',
    15005: 'local_heir_adm',
    15006: 'local_heir_dip',
    15007: 'local_heir_mil',
    15008: 'hegemon_strength',
    15009: 'any_great_power',
    15010: 'any_other_great_power',
    15011: 'join_trade_league',
    15012: 'convert_leader_to_general',
    15013: 'hired_for_months',
    15014: 'has_any_active_estate_agenda',
    15015: 'remove_named_unrest',
    15016: 'global_heathen_missionary_strength',
    15017: 'block_disinherit',
    15018: 'block_introduce_heir',
    15019: 'province_religion',
    15020: 'native_culture',
    15021: 'negative_balance_in_two_months',
    15022: 'current_income_balance',
    15023: 'enables_streltsy_regiments',
    15024: 'used_governing_capacity',
    15025: 'statewide_governing_cost',
    15026: 'as_if_faction',
    15027: 'cooldown_months',
    15028: 'interactions_last_used',
    15029: 'land_share',
    15030: 'claimed',
    15031: 'uses_hussite_power',
    15032: 'add_all_provinces_to_hre',
    15033: 'land_ownership_modifier',
    15034: 'pick',
    15035: 'lock_curia',
    15036: 'papal_influence_from_cardinals',
    15037: 'cavalry_cap',
    15038: 'finish_council',
    15039: 'custom_gui',
    15040: 'governing_capacity',
    15041: 'governing_cost',
    15042: 'local_governing_cost',
    15043: 'governing_capacity_modifier',
    15044: 'colonial_region_for_scope_province',
    15045: 'local_religious_conversion_resistance',
    15046: 'global_religious_conversion_resistance',
    15047: 'post_removed_effect',
    15048: 'restrict_charter',
    15049: 'build_trigger',
    15050: 'keep_trigger',
    15051: 'saved_character_entry',
    15052: 'emperor_temp_johan_07',
    15053: 'emperor_temp_johan_08',
    15054: 'emperor_temp_johan_09',
    15055: 'emperor_temp_johan_10',
    15056: 'emperor_temp_johan_11',
    15057: 'emperor_temp_johan_12',
    15058: 'emperor_temp_johan_13',
    15059: 'emperor_temp_johan_14',
    15060: 'emperor_temp_johan_15',
    15061: 'emperor_temp_johan_16',
    15062: 'emperor_temp_johan_17',
    15063: 'emperor_temp_johan_18',
    15064: 'emperor_temp_johan_19',
    15065: 'show_subscription_banner',
    15066: 'gs_message_seen',
    15067: 'create_succession_crisis',
    15068: 'revolutionary_client_state',
    15069: 'can_use_peace_treaty',
    15070: 'treaty',
    15071: 'emperor_temp_henrik_5',
    15072: 'emperor_temp_henrik_6',
    15073: 'emperor_temp_henrik_7',
    15074: 'emperor_temp_henrik_8',
    15075: 'emperor_temp_henrik_9',
    15076: 'emperor_temp_henrik_10',
    15077: 'emperor_temp_henrik_11',
    15078: 'emperor_temp_henrik_12',
    15079: 'emperor_temp_henrik_13',
    15080: 'emperor_temp_henrik_14',
    15081: 'emperor_temp_henrik_15',
    15082: 'emperor_temp_henrik_16',
    15083: 'emperor_temp_henrik_17',
    15084: 'emperor_temp_henrik_18',
    15085: 'emperor_temp_henrik_19',
    15086: 'major_trigger',
    15087: 'cvaa_settings',
    15088: 'cvaa_tts_enabled',
    15089: 'cvaa_stt_enabled',
    15090: 'cvaa_chat_visual_alerts',
    15091: 'cvaa_stt_hotkey_enabled',
    15092: 'cvaa_stt_hotkey_value',
    15093: 'cvaa_chat_large_fonts',
    15094: 'hotkey_activation_delay',
    15095: 'hotkey_actualization_delay',
    15096: 'roger_1',
    15097: 'roger_2',
    15098: 'roger_3',
    15099: 'roger_4',
    15100: 'roger_5',
    15101: 'roger_6',
    15102: 'roger_7',
    15103: 'roger_8',
    15104: 'roger_9',
    15105: 'roger_10',
    15106: 'custom_country_set_sprite_packs_command',
    15107: 'henrik_1',
    15108: 'any_country_active_in_node',
    15109: 'is_excommunication',
    15110: 'henrik_4',
    15111: 'henrik_5',
    15112: 'henrik_6',
    15113: 'henrik_7',
    15114: 'henrik_8',
    15115: 'henrik_9',
    15116: 'henrik_10',
    15117: 'sub_message_seen',
    15118: 'disable_third_party_content',
    15119: 'subscription_highlights',
};
exports.default = dict;
